<template>
    <div id="resourcelisting" class="overseas-pc">
        <div class="resou-title"><span>企业出海 》出海活动</span></div>
        <div class="overseas-main-columns" :style="{ height: tabmaxheight + 'px' }">
            <div class="overseas-main-panel" :style="{ border: '1px solid #f2f2f2', width: rightwidth + 'px' }">
                <div class="demotitle">
                    <div style="padding-right: 10px;">
                        <div class="block"></div>
                        <span class="xiaosho" :style="{ color: currentView === 'activity' ? '#0079FE' : '' }" @click="switchOverseasView('activity')">出海活动</span>
                        <span style="float: right;">
                            <span class="access_tags" @click="switchOverseasView('cocreate')">
                                <span class="xiaosho">共创中心</span>
                                <div style="margin-top: 0" v-show="currentView === 'cocreate'" class="access_tagsyshi"></div>
                            </span>
                            <el-divider direction="vertical"></el-divider>
                            <span class="access_tags" @click="switchOverseasView('member')">
                                <span class="xiaosho">会员</span>
                                <div style="margin-top: 0" v-show="currentView === 'member'" class="access_tagsyshi"></div>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="demoheader">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item v-if="currentView === 'activity'" label="活动状态:">
                            <el-select v-model="formInline.meetingStatus" clearable filterable allow-create default-first-option placeholder="请选择活动状态" style="width:180px;">
                                <el-option v-for="item in meetingStatusOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-else-if="currentView === 'cocreate'" label="名称:">
                            <el-input v-model.trim="formInline.innovationName" clearable maxlength="60" placeholder="请输入共创中心名称" style="width:220px;" @keyup.enter.native="refreshList"></el-input>
                        </el-form-item>
                        <template v-else-if="currentView === 'member'">
                            <el-form-item label="会员姓名:">
                                <el-input v-model.trim="formInline.memberKeyword" clearable maxlength="30" placeholder="请输入会员姓名" style="width:180px;" @keyup.enter.native="refreshList"></el-input>
                            </el-form-item>
                            <el-form-item label="共创中心:">
                                <el-select v-model="formInline.memberCenterId" clearable filterable placeholder="请选择共创中心" style="width:220px;" :loading="memberCenterOptionsLoading">
                                    <el-option v-for="item in memberCenterOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <el-form-item v-else label="出海国家:">
                            <el-select v-model="formInline.continent" clearable placeholder="请选择洲别" style="width:180px;" @change="selectContinent">
                                <el-option v-for="item in continents" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">查询</el-button>
                            <el-button size="mini" @click="clearItem">重置</el-button>
                            <el-button v-if="currentView === 'activity'" type="primary" size="mini" icon="el-icon-plus" @click="openMeetingPublish">新增出海活动</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-plus" @click="openApplyDialog">申请加入</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-loading="loading" class="overflow" :style="{ height: tabmaxheight - 100 + 'px', background: '#fff', padding: '0 10px' }">
                    <template v-if="currentView === 'activity'">
                        <div v-for="item in forumList" :key="item.id" class="overseas-list-item" :class="{ 'has-meeting-actions': isAuditAdmin,'has-two-actions': isAuditAdmin,'has-three-actions': isAuditAdmin }" style="padding: 14px 8px; border-bottom: 1px solid #f2f2f2; cursor: pointer;" @click="openMeeting(item)">
                            <el-row class="elasticbox">
                                <el-col :span="5"><img :src="item.cover" @error="useForumFallback" style="width:140px;height:64px;object-fit:contain;border-radius:4px;background:#f7f8fa;" alt=""></el-col>
                                <el-col :span="19" class="overseas-list-content" style="padding:4px 0;">
                                    <p class="hideellipsis" style="font-size:15px;font-weight:500;margin-bottom:8px;">{{ item.title }} <span v-if="item.status" style="color:#f29b2e;font-size:12px;margin-left:10px;">{{ item.status }}</span><span v-if="auditStatusText(item.audit_status)" class="audit-status-text" :class="auditStatusClass(item.audit_status)">{{ auditStatusText(item.audit_status) }}</span></p>
                                    <p class="hideellipsis" style="color:#7c8496;margin-bottom:8px;">{{ item.desc || '暂无会议描述' }}</p>
                                    <p style="color:#7c8496;margin-bottom:6px;"><i class="el-icon-date"></i> 会议时间：{{ item.time || '--' }}</p>
                                    <p style="color:#7c8496"><i class="el-icon-location-outline"></i> 会议地址：{{ item.address || '--' }} <span class="meeting-participant-entry"><span>参会人数：{{ item.count || '0人' }}</span><el-button type="text" size="mini" @click.stop="openMeetingParticipants(item)">参会人员</el-button></span></p>
                                </el-col>
                            </el-row>
                            <div v-if="isAuditAdmin" class="overseas-meeting-actions">
                                <el-button size="mini" type="warning" plain @click.stop="openMeetingEditor(item)">编辑</el-button>
                                <el-button size="mini" type="primary" plain @click.stop="openAuditDialog('meeting',item)">审核</el-button>
                                <el-button size="mini" type="danger" plain :loading="meetingDeletingId === item.id" @click.stop="deleteMeeting(item)">删除</el-button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="currentView === 'cocreate'">
                        <div v-for="item in innovationList" :key="item.id" class="overseas-list-item" :class="{ 'has-innovation-actions': isAuditAdmin }" style="padding:14px 8px;border-bottom:1px solid #f2f2f2;cursor:pointer;" @click="openInnovation(item)">
                            <el-row class="elasticbox">
                                <el-col :span="5"><img :src="item.cover" @error="useMemberFallback" style="width:140px;height:90px;object-fit:cover;border-radius:4px;" alt=""></el-col>
                                <el-col :span="19" class="overseas-list-content" style="padding:4px 0;">
                                    <p class="hideellipsis" style="font-size:15px;font-weight:500;margin-bottom:8px;"><span style="display:inline-block;width:4px;height:14px;background:#0079FE;margin-right:8px;vertical-align:-2px;"></span>{{ item.title }}<span v-if="auditStatusText(item.audit_status)" class="audit-status-text" :class="auditStatusClass(item.audit_status)">{{ auditStatusText(item.audit_status) }}</span></p>
                                    <p class="hideellipsis" style="color:#7c8496;margin-bottom:12px;">{{ item.desc || '暂无共创中心介绍' }}</p>
                                    <p style="color:#8c949f;">发起人：{{ item.owner || '--' }} <span style="float:right;color:#a928c9;">会员人数：{{ item.count || '0人' }}</span></p>
                                </el-col>
                            </el-row>
                            <div v-if="isAuditAdmin" class="overseas-innovation-actions">
                                <el-button size="mini" type="warning" plain @click.stop="openInnovationEditor(item)">编辑</el-button>
                                <el-button size="mini" type="danger" plain :loading="innovationDeletingId === item.id" @click.stop="deleteInnovation(item)">删除</el-button>
                                <el-button size="mini" type="primary" plain @click.stop="openAuditDialog('innovation',item)">审核</el-button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="currentView === 'member'">
                        <div v-for="item in innovationMemberList" :key="item.id || item.userId" style="padding:14px 18px;border-bottom:1px solid #f2f2f2;">
                            <el-row class="elasticbox" type="flex" align="middle">
                                <el-col :span="3"><img :src="item.avatar" @error="useMemberFallback" style="width:52px;height:52px;border-radius:50%;object-fit:cover;" alt=""></el-col>
                                <el-col :span="16"><p style="font-size:15px;font-weight:500;margin-bottom:8px;">{{ item.name }}</p><p style="color:#7c8496;">{{ item.centerName || '共创中心会员' }}</p></el-col>
                                <el-col :span="5" style="text-align:right;"><el-button type="text" icon="el-icon-chat-dot-round" @click="openMemberChat(item)">沟通</el-button></el-col>
                            </el-row>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="item in countryViewList" :key="item.id" style="padding:14px 8px;border-bottom:1px solid #f2f2f2;cursor:pointer;" @click="openCountry(item)">
                            <el-row class="elasticbox">
                                <el-col :span="5"><img :src="item.cover" @error="useMemberFallback" style="width:140px;height:90px;object-fit:cover;border-radius:4px;" alt=""></el-col>
                                <el-col :span="19" style="padding:4px 0;">
                                    <p style="font-size:15px;font-weight:500;margin-bottom:8px;">{{ item.title || item.country }}</p>
                                    <p class="hideellipsis" style="color:#7c8496;margin-bottom:8px;">{{ item.desc || '暂无国家介绍' }}</p>
                                    <p style="color:#7c8496;margin-bottom:8px;">资源特产：{{ item.resource || '--' }} <span style="float:right;color:#438df0;">进出口额：{{ item.trade || '--' }}</span></p>
                                    <p style="color:#8c949f"><i class="el-icon-location-outline"></i> {{ item.address || '--' }} <span style="float:right;color:#a928c9;">{{ item.follow || '0人' }}</span></p>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                    <el-empty v-if="!loading && !currentListLength" :description="emptyDescription"></el-empty>
                </div>
            </div>
            <div class="overseas-country-sidebar" :style="{ background:'#fff',border:'1px solid #f2f2f2',width:leftwidth }" v-show="actab">
                <div class="country-sidebar-header" style="padding:5px;height:39px;line-height:30px;white-space:nowrap;border-bottom:1px solid #EBEEF5;text-align:center;">
                    <i v-show="!foldshow" @click="foldshowclick" class="el-icon-s-fold xiaosho" style="font-size:20px;margin-top:5px;float:left;"></i>
                    <i v-show="foldshow" @click="foldshowclick" class="el-icon-s-unfold xiaosho" style="font-size:20px;margin-top:5px;float:left;"></i>
                    <div style="display:inline-block;vertical-align:top;" v-if="foldshow">出海国家</div>
                    <el-tooltip v-if="foldshow && isAuditAdmin" content="新增国家" placement="top">
                        <el-button type="text" icon="el-icon-plus" class="country-add-button" @click="openCountryEditor()"></el-button>
                    </el-tooltip>
                </div>
                <ul v-loading="countrySidebarLoading" class="userzufujilist country-sidebar-list" v-show="foldshow">
                    <li class="xiaosho country-sidebar-item" v-for="item in countryList" :key="item.id" @click="openCountry(item)">
                        <div class="country-sidebar-main">
                            <img :src="item.cover" @error="useMemberFallback" width="40" height="40" alt="">
                            <span>{{ item.country || item.title }}</span>
                        </div>
                        <div v-if="isAuditAdmin" class="country-sidebar-actions">
                            <el-tooltip content="编辑" placement="top"><el-button type="text" icon="el-icon-edit" @click.stop="openCountryEditor(item)"></el-button></el-tooltip>
                            <el-tooltip content="删除" placement="top"><el-button type="text" icon="el-icon-delete" class="country-delete-button" :loading="countryDeletingId === item.id" @click.stop="deleteCountry(item)"></el-button></el-tooltip>
                        </div>
                    </li>
                </ul>
                <div class="country-sidebar-pagination" v-show="foldshow">
                    <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :current-page="countrySidebarPage"
                        :page-size="countrySidebarPageSize"
                        :total="countrySidebarTotal"
                        @current-change="handleCountrySidebarPageChange"
                    ></el-pagination>
                </div>
                <div v-show="!foldshow" :style="{ height: tabmaxheight + 'px', width: '3%' }"></div>
            </div>
        </div>
        <el-dialog
            v-dialogDrag
            :title="applyMode === 'join' ? '申请加入共创中心' : innovationEditing ? '编辑共创中心' : '共创中心申请'"
            :visible.sync="applyVisible"
            width="900px"
            top="6vh"
            class="overseas-local-dialog"
            custom-class="overseas-application-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            @closed="resetApplyDialog"
        >
            <div class="innovation-application-body">
                <el-tabs v-if="applyMode === 'create' && !innovationEditing" v-model="applyView" @tab-click="handleApplyTabClick">
                    <el-tab-pane label="成立共创中心" name="form">
                        <el-form ref="applyForm" :model="applyForm" :rules="applyRules" label-width="100px" size="small">
                            <div class="innovation-create-grid">
                                <div class="innovation-create-fields">
                                    <el-form-item label="中心名称" prop="name"><el-input v-model="applyForm.name" maxlength="50" placeholder="请输入共创中心名称"></el-input></el-form-item>
                                    <el-form-item label="创始人" prop="founderName"><el-input v-model="applyForm.founderName" maxlength="30" placeholder="请输入创始人姓名"></el-input></el-form-item>
                                    <el-form-item label="联系电话" prop="contactPhone"><el-input v-model="applyForm.contactPhone" maxlength="20" placeholder="请输入联系电话"></el-input></el-form-item>
                                </div>
                                <el-form-item label="封面图" class="innovation-create-cover-item">
                                    <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false" :on-change="handleInnovationCoverChange">
                                        <div class="innovation-cover-upload">
                                            <img v-if="applyForm.coverPreview" :src="applyForm.coverPreview" alt="共创中心封面">
                                            <div v-else><i class="el-icon-plus"></i><span>上传封面图</span></div>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <el-form-item label="联系地址"><el-input v-model="applyForm.address" maxlength="100" placeholder="请输入联系地址"></el-input></el-form-item>
                            <el-form-item label="中心简介"><el-input v-model="applyForm.description" type="textarea" :rows="4" maxlength="300" show-word-limit placeholder="请输入共创中心简介"></el-input></el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="申请记录" name="records">
                        <el-table v-loading="applicationRecordsLoading" :data="applicationRecords" border stripe
                            class="innovation-application-record-table" empty-text="暂无申请记录">
                            <el-table-column label="封面" width="76" align="center"><template slot-scope="scope"><img :src="scope.row.cover" class="application-record-cover" @error="useMemberFallback" alt=""></template></el-table-column>
                            <el-table-column prop="title" label="共创中心" min-width="130" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="owner" label="创始人" width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="applyTime" label="申请时间" width="110"></el-table-column>
                            <el-table-column label="审核状态" width="105" align="center"><template slot-scope="scope"><span :class="auditStatusClass(scope.row.audit_status)">{{ auditStatusText(scope.row.audit_status) || '待审核' }}</span></template></el-table-column>
                            <el-table-column prop="auditRemark" label="审核备注" min-width="130" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <el-form v-else-if="applyMode === 'join'" ref="applyForm" :model="applyForm" label-width="100px" size="small">
                    <el-form-item label="共创中心"><el-input :value="applyTarget.title || '--'" disabled></el-input></el-form-item>
                    <el-row :gutter="16">
                        <el-col :span="12"><el-form-item label="姓名"><el-input v-model="applyForm.founderName" disabled></el-input></el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="手机号"><el-input v-model="applyForm.contactPhone" disabled></el-input></el-form-item></el-col>
                    </el-row>
                    <el-form-item label="申请备注"><el-input v-model="applyForm.remark" type="textarea" :rows="4" maxlength="300" show-word-limit placeholder="请输入申请备注"></el-input></el-form-item>
                </el-form>
                <el-form v-else ref="applyForm" :model="applyForm" :rules="applyRules" label-width="100px" size="small">
                    <div v-loading="innovationEditorLoading" class="innovation-create-grid">
                        <div class="innovation-create-fields">
                            <el-form-item label="中心名称" prop="name"><el-input v-model="applyForm.name" maxlength="50" placeholder="请输入共创中心名称"></el-input></el-form-item>
                            <el-form-item label="创始人" prop="founderName"><el-input v-model="applyForm.founderName" maxlength="30" placeholder="请输入创始人姓名"></el-input></el-form-item>
                            <el-form-item label="联系电话" prop="contactPhone"><el-input v-model="applyForm.contactPhone" maxlength="20" placeholder="请输入联系电话"></el-input></el-form-item>
                        </div>
                        <el-form-item label="封面图" class="innovation-create-cover-item">
                            <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false" :on-change="handleInnovationCoverChange">
                                <div class="innovation-cover-upload" v-loading="applyForm.coverUploading">
                                    <img v-if="applyForm.coverPreview" :src="applyForm.coverPreview" alt="共创中心封面">
                                    <div v-else><i class="el-icon-plus"></i><span>上传封面图</span></div>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item label="联系地址"><el-input v-model="applyForm.address" maxlength="100" placeholder="请输入联系地址"></el-input></el-form-item>
                    <el-form-item label="中心简介"><el-input v-model="applyForm.description" type="textarea" :rows="4" maxlength="300" show-word-limit placeholder="请输入共创中心简介"></el-input></el-form-item>
                </el-form>
            </div>
            <span v-if="applyMode === 'join' || applyView === 'form' || innovationEditing" slot="footer"><el-button @click="applyVisible=false">取消</el-button><el-button type="primary" :loading="actionLoading" @click="submitApply">{{ innovationEditing ? '保存' : '提交申请' }}</el-button></span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="auditTarget.type === 'meeting' ? '会议审核' : '共创中心审核'"
            :visible.sync="auditVisible"
            width="520px"
            class="overseas-local-dialog"
            custom-class="overseas-audit-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            @closed="resetAuditForm"
        >
            <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="90px">
                <el-form-item label="审核对象"><el-input :value="auditTarget.title || '--'" disabled></el-input></el-form-item>
                <el-form-item label="审核结果" prop="status"><el-radio-group v-model="auditForm.status"><el-radio :label="1">通过</el-radio><el-radio :label="2">不通过</el-radio></el-radio-group></el-form-item>
                <el-form-item label="审核备注"><el-input v-model="auditForm.remark" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入审核备注"></el-input></el-form-item>
            </el-form>
            <span slot="footer"><el-button @click="auditVisible=false">取消</el-button><el-button type="primary" :loading="auditSubmitting" @click="submitAudit">确认审核</el-button></span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="countryForm.id ? '编辑海外国家' : '新增海外国家'"
            :visible.sync="countryEditorVisible"
            width="820px"
            top="5vh"
            class="overseas-local-dialog"
            custom-class="overseas-country-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            @closed="resetCountryForm"
        >
            <div v-loading="countryFormLoading" class="country-form-body">
                <el-form ref="countryForm" :model="countryForm" :rules="countryRules" label-width="100px" size="small">
                    <div class="country-editor-main">
                        <div class="country-editor-fields">
                            <el-form-item label="国家名称" prop="name"><el-input v-model="countryForm.name" maxlength="60" placeholder="请输入国家名称"></el-input></el-form-item>
                            <el-form-item label="所属洲别" prop="continent"><el-select v-model="countryForm.continent" placeholder="请选择洲别" style="width:100%;"><el-option v-for="item in continents" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-form-item>
                            <el-form-item label="进出口额"><el-input v-model="countryForm.importExportAmount" maxlength="60" placeholder="例如：2亿美元"></el-input></el-form-item>
                        </div>
                        <el-form-item label="国旗图片" class="country-flag-form-item">
                            <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false" :on-change="handleCountryFlagChange">
                                <div class="country-flag-upload" v-loading="countryFlagUploading">
                                    <img v-if="countryForm.flagPreview" :src="countryForm.flagPreview" alt="国旗图片">
                                    <div v-else><i class="el-icon-camera"></i><span>上传国旗</span></div>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item label="地址" class="country-full-row"><el-input v-model="countryForm.address" maxlength="120" placeholder="请输入地址"></el-input></el-form-item>
                    <el-form-item label="资源特产"><el-input v-model="countryForm.resourceSpecialty" maxlength="200" placeholder="请输入资源特产"></el-input></el-form-item>
                    <el-form-item label="大使馆信息"><el-input v-model="countryForm.embassyInfo" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请输入大使馆信息"></el-input></el-form-item>
                    <el-form-item label="国家描述"><el-input v-model="countryForm.description" type="textarea" :rows="4" maxlength="1000" show-word-limit placeholder="请输入国家描述"></el-input></el-form-item>
                </el-form>
            </div>
            <span slot="footer"><el-button @click="countryEditorVisible=false">取消</el-button><el-button type="primary" :loading="countrySaving" @click="saveCountry">保存</el-button></span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="meetingEditing ? '编辑出海活动' : '新增出海活动'"
            :visible.sync="meetingPublishVisible"
            width="760px"
            top="4vh"
            class="overseas-local-dialog"
            custom-class="overseas-publish-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            @closed="resetMeetingPublish"
        >
            <div v-loading="meetingFormLoading" class="meeting-publish-body">
                <el-form ref="meetingPublishForm" :model="meetingForm" :rules="meetingRules" label-width="110px" size="small">
                    <el-row :gutter="18">
                        <el-col :span="12"><el-form-item label="会议名称" prop="name"><el-input v-model="meetingForm.name" maxlength="60" placeholder="请输入会议名称"></el-input></el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="主办企业"><el-input :value="meetingEnterpriseName || '暂无企业信息'" disabled></el-input></el-form-item></el-col>
                    </el-row>
                    <el-form-item label="活动时间" prop="timeRange">
                        <el-date-picker v-model="meetingForm.timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-row :gutter="18">
                        <el-col :span="12"><el-form-item label="会议地点"><el-input v-model="meetingForm.location" maxlength="100" placeholder="请输入会议地点"></el-input></el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="联系人"><el-input v-model="meetingForm.contactPerson" maxlength="30" placeholder="请输入联系人"></el-input></el-form-item></el-col>
                    </el-row>
                    <el-row :gutter="18">
                        <el-col :span="8"><el-form-item label="联系电话"><el-input v-model="meetingForm.contactPhone" maxlength="20" placeholder="请输入联系电话"></el-input></el-form-item></el-col>
                        <el-col :span="8"><el-form-item label="最大参会人数"><el-input-number v-model="meetingForm.maxParticipants" :min="0" :max="99999999" controls-position="right" style="width:100%;"></el-input-number></el-form-item></el-col>
                        <el-col :span="8"><el-form-item label="活动价格"><el-input-number v-model="meetingForm.price" :min="0" :precision="2" :max="99999999" controls-position="right" style="width:100%;"></el-input-number></el-form-item></el-col>
                    </el-row>
                    <el-form-item v-if="meetingEditing" label="审核状态">
                        <el-select v-model="meetingForm.auditStatus" style="width:100%;" placeholder="请选择审核状态">
                            <el-option v-for="item in meetingAuditStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动封面">
                        <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false" :on-change="handleMeetingCoverChange">
                            <div class="meeting-cover-upload" v-loading="meetingCoverUploading">
                                <img v-if="meetingForm.coverPreview" :src="meetingForm.coverPreview" alt="活动封面">
                                <div v-else class="meeting-cover-empty"><i class="el-icon-camera"></i><span>上传活动封面</span></div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="活动描述"><el-input v-model="meetingForm.description" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请输入活动描述"></el-input></el-form-item>
                    <el-form-item label="会议内容"><el-input v-model="meetingForm.content" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入会议内容"></el-input></el-form-item>
                    <div class="meeting-leader-head"><span>参会领导</span><el-button type="text" icon="el-icon-plus" @click="addMeetingLeader">添加领导</el-button></div>
                    <div v-for="(leader,index) in meetingLeaders" :key="leader.key" class="meeting-leader-item">
                        <div class="meeting-leader-title"><span>领导 {{ index + 1 }}</span><el-button type="text" class="meeting-leader-delete" @click="removeMeetingLeader(index)">删除</el-button></div>
                        <el-row :gutter="14">
                            <el-col :span="5">
                                <el-upload action="#" accept="image/*" :show-file-list="false" :auto-upload="false" :on-change="(file,fileList) => handleLeaderAvatarChange(file,fileList,index)">
                                    <div class="meeting-leader-avatar" v-loading="leader.uploading">
                                        <img v-if="leader.avatarPreview" :src="leader.avatarPreview" alt="领导头像">
                                        <i v-else class="el-icon-camera"></i>
                                    </div>
                                </el-upload>
                            </el-col>
                            <el-col :span="19">
                                <el-row :gutter="12">
                                    <el-col :span="10"><el-input v-model="leader.name" maxlength="30" placeholder="领导姓名"></el-input></el-col>
                                    <el-col :span="14"><el-date-picker v-model="leader.attendTime" type="datetime" placeholder="参会时间" style="width:100%;"></el-date-picker></el-col>
                                </el-row>
                                <el-input v-model="leader.description" type="textarea" :rows="2" maxlength="100" placeholder="领导简介" style="margin-top:10px;"></el-input>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <span slot="footer"><el-button @click="meetingPublishVisible=false">取消</el-button><el-button type="primary" :loading="meetingPublishing" @click="submitMeetingPublish">{{ meetingEditing ? '保存' : '发布活动' }}</el-button></span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="detailTitle"
            :visible.sync="detailVisible"
            width="760px"
            top="5vh"
            class="overseas-local-dialog"
            custom-class="overseas-detail-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
        >
            <div v-loading="detailLoading" class="overseas-detail-body">
                <template v-if="detail.type === 'meeting'">
                    <img v-if="detail.cover" :src="detail.cover" class="meeting-detail-cover" alt="活动封面">
                    <div class="meeting-detail-title-row">
                        <h3>{{ detail.title || '--' }}</h3>
                        <el-tag v-if="detail.status" size="small" type="warning">{{ detail.status }}</el-tag>
                    </div>
                    <div class="meeting-detail-stats">
                        <div><strong>{{ meetingRegisteredCount }}</strong><span>已报名人数</span></div>
                        <div><strong>{{ detail.max_participants || 0 }}</strong><span>最大人数</span></div>
                        <div><strong>{{ meetingTicketText }}</strong><span>票种</span></div>
                    </div>
                    <div class="meeting-detail-grid">
                        <div><span>主办企业</span><p>{{ detail.enterprise_name || '--' }}</p></div>
                        <div><span>协办企业</span><p>{{ detail.co_host_enterprise_name || '--' }}</p></div>
                        <div><span>开始时间</span><p>{{ formatDate(detail.start_time) || '--' }}</p></div>
                        <div><span>结束时间</span><p>{{ formatDate(detail.end_time) || '--' }}</p></div>
                        <div><span>会议地址</span><p>{{ detail.location || detail.address || '--' }}</p></div>
                        <div><span>联系人</span><p>{{ detail.contact_person || '--' }}</p></div>
                        <div><span>联系电话</span><p>{{ detail.contact_phone || '--' }}</p></div>
                        <div><span>活动价格</span><p>{{ meetingPriceText }}</p></div>
                        <div v-if="detail.created_at || detail.create_time"><span>创建时间</span><p>{{ formatDate(detail.created_at || detail.create_time) }}</p></div>
                        <div v-if="detail.updated_at || detail.update_time"><span>更新时间</span><p>{{ formatDate(detail.updated_at || detail.update_time) }}</p></div>
                    </div>
                    <div class="meeting-detail-section">
                        <h4>活动描述</h4>
                        <p>{{ stripHtml(detail.description) || '暂无活动描述' }}</p>
                    </div>
                    <div class="meeting-detail-section">
                        <h4>会议内容</h4>
                        <p>{{ stripHtml(detail.content) || '暂无会议内容' }}</p>
                    </div>
                    <div class="meeting-detail-section">
                        <h4>参会领导</h4>
                        <div v-if="meetingDetailLeaders.length" class="meeting-person-list">
                            <div v-for="(leader,index) in meetingDetailLeaders" :key="leader.id || leader.name || index" class="meeting-person-item">
                                <img :src="imageUrl(leader.avatar,'/static/global/overseas-member-cover.png')" @error="useMemberFallback" alt="">
                                <div><strong>{{ leader.name || '--' }}</strong><p>{{ leader.description || '暂无简介' }}</p><span v-if="leader.attend_time">参会时间：{{ formatDate(leader.attend_time) }}</span></div>
                            </div>
                        </div>
                        <p v-else class="meeting-detail-empty">暂无参会领导</p>
                    </div>
                    <div class="meeting-detail-section">
                        <h4>报名人员</h4>
                        <div v-if="meetingSignupUsers.length" class="meeting-signup-list">
                            <div v-for="(user,index) in meetingSignupUsers" :key="user.id || user.user_id || index">
                                <img :src="imageUrl(user.user_avatar || user.avatar,'/static/global/overseas-member-cover.png')" @error="useMemberFallback" alt="">
                                <span>{{ user.user_name || user.name || '用户' }}</span>
                            </div>
                        </div>
                        <p v-else class="meeting-detail-empty">暂无报名人员</p>
                    </div>
                </template>
                <template v-else>
                    <img v-if="detail.cover" :src="detail.cover" class="meeting-detail-cover" alt="">
                    <h3 class="generic-detail-title">{{ detail.title || '--' }}</h3>
                    <p class="generic-detail-text">{{ detail.desc || '暂无详细介绍' }}</p>
                    <p v-if="detail.time" class="generic-detail-text"><i class="el-icon-date"></i> {{ detail.time }}</p>
                    <p v-if="detail.address" class="generic-detail-text"><i class="el-icon-location-outline"></i> {{ detail.address }}</p>
                </template>
            </div>
            <span v-if="detail.type === 'meeting'" slot="footer" class="meeting-detail-footer">
                <span v-if="meetingActionMessage" class="meeting-action-message" :class="'is-'+meetingActionMessageType">
                    <i :class="meetingActionMessageType === 'success' ? 'el-icon-success' : 'el-icon-warning-outline'"></i>
                    {{ meetingActionMessage }}
                </span>
                <span v-else></span>
                <el-button type="primary" :loading="actionLoading" @click="toggleMeetingSignup">{{ detail.signedUp ? '取消报名' : '立即报名' }}</el-button>
            </span>
            <span v-else-if="detail.type === 'innovation'" slot="footer"><el-button type="primary" :loading="actionLoading" @click="detail.joined ? toggleInnovationJoin() : openInnovationJoinDialog()">{{ detail.joined ? '退出共创中心' : '申请加入' }}</el-button></span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="participantDialogTitle"
            :visible.sync="participantVisible"
            width="820px"
            top="8vh"
            class="overseas-local-dialog"
            custom-class="overseas-participant-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
        >
            <el-table
                v-loading="participantLoading"
                :data="participantList"
                border
                stripe
                height="420"
                empty-text="暂无参会人员"
                class="meeting-participant-table"
            >
                <el-table-column prop="name" label="姓名" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gender" label="性别" width="90" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号码" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="company" label="所属公司" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column prop="position" label="职位" min-width="140" show-overflow-tooltip></el-table-column>
            </el-table>
            <span slot="footer" class="participant-dialog-footer">
                <span>共 {{ participantList.length }} 人</span>
                <span><el-button @click="participantVisible=false">关闭</el-button><el-button type="primary" icon="el-icon-download" :disabled="!participantList.length || participantLoading" @click="exportMeetingParticipants">导出参会人员列表</el-button></span>
            </span>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            :title="cropperTitle"
            :visible.sync="cropperModel.val"
            width="1100px"
            top="5vh"
            custom-class="overseas-cropper-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            v-if="cropperModel.val"
            @closed="resetCropper"
        >
            <v-vuecropper
                :key="cropperKey"
                :cropperModel="cropperModel"
                :imgFile="cropperFile"
                :imgW="cropperWidth"
                :imgH="cropperHeight"
                :fixedNumber="cropperFixedNumber"
                :fixed="true"
                :outputW="cropperOutputWidth"
                :outputH="cropperOutputHeight"
                :outputType="cropperOutputType"
                v-on:upload="handleCroppedImage"
            ></v-vuecropper>
        </el-dialog>
        <el-dialog
            v-dialogDrag
            title="删除确认"
            :visible.sync="deleteConfirmVisible"
            width="420px"
            class="overseas-local-dialog"
            custom-class="overseas-delete-dialog"
            :modal-append-to-body="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="!deleteConfirmLoading"
            :show-close="!deleteConfirmLoading"
            @closed="resetDeleteConfirm"
        >
            <div class="overseas-delete-confirm">
                <i class="el-icon-warning"></i>
                <span>{{ deleteConfirmMessage }}</span>
            </div>
            <span slot="footer">
                <el-button :disabled="deleteConfirmLoading" @click="deleteConfirmVisible=false">取消</el-button>
                <el-button type="danger" :loading="deleteConfirmLoading" @click="confirmDelete">删除</el-button>
            </span>
        </el-dialog>
        <div class="cr_footer"><div class="footer_left"><i class="el-icon-place"></i><div id="box"><ul id="con1" :class="{ anim:animate }"><li v-for="item in items" :key="item.name">{{ item.name }}</li></ul></div></div></div>
    </div>
</template>
<script>
import "../common/common.css";
import vuecropper from "../commonComponents/vueCropper.vue";
const FORUM_FALLBACK = '/static/global/overseas-forum-cover.png';
const MEMBER_FALLBACK = '/static/global/overseas-member-cover.png';

function createMeetingForm(user) {
    const start = new Date();
    start.setSeconds(0,0);
    const end = new Date(start.getTime()+2*60*60*1000);
    return {
        name:'',timeRange:[start,end],location:'',
        contactPerson:String(user.name || user.real_name || user.user_name || user.uname || '').trim(),
        contactPhone:String(user.phone || user.mobile || user.phone_number || '').trim(),
        maxParticipants:0,price:0,auditStatus:0,coverImage:'',coverFile:null,coverPreview:'',description:'',content:'',
        coHostEnterpriseId:'',coHostEnterpriseName:''
    };
}

function createCountryForm() {
    return {
        id:'',name:'',flagImage:'',flagPreview:'',continent:'',importExportAmount:'',
        embassyInfo:'',address:'',resourceSpecialty:'',description:''
    };
}

function createInnovationApplyForm(user={}) {
    return {
        name:'',
        founderName:String(user.name || user.real_name || user.user_name || user.nickname || user.uname || '').trim(),
        contactPhone:String(user.phone || user.mobile || user.phone_number || '').trim(),
        address:'',description:'',coverImage:'',coverFile:null,coverPreview:'',coverUploading:false,founderId:'',founderAvatar:'',remark:''
    };
}

export default {
    name: 'GlobalOverseas',
    components: {
        "v-vuecropper": vuecropper
    },
    data() {
        const user = this.getStoredUser();
        return {
            tabmaxheight: window.innerHeight - 200,
            rightwidth: window.innerWidth - 390,
            leftwidth: '300px',
            currentView: 'activity',
            actab: true,
            foldshow: true,
            loading: false,
            detailLoading: false,
            actionLoading: false,
            meetingActionMessage: '',
            meetingActionMessageType: 'error',
            auditVisible: false,
            auditSubmitting: false,
            auditTarget: {},
            auditForm: { status:1,remark:'' },
            auditRules: { status:[{ required:true,message:'请选择审核结果',trigger:'change' }] },
            applyVisible: false,
            applyMode: 'create',
            applyView: 'form',
            applyTarget: {},
            applicationRecords: [],
            applicationRecordsLoading: false,
            applicationRecordsLoaded: false,
            innovationEditing: false,
            innovationEditorLoading: false,
            detailVisible: false,
            participantVisible: false,
            participantLoading: false,
            participantMeeting: {},
            participantList: [],
            meetingPublishVisible: false,
            meetingPublishing: false,
            meetingEditing: false,
            meetingEditId: '',
            meetingFormLoading: false,
            meetingCoverUploading: false,
            meetingDeletingId: '',
            innovationDeletingId: '',
            deleteConfirmVisible: false,
            deleteConfirmLoading: false,
            deleteConfirmType: '',
            deleteConfirmTarget: {},
            meetingLeaderKey: 0,
            detailTitle: '',
            formInline: {
                meetingStatus:'',innovationName:'',memberKeyword:'',memberCenterId:'',continent:''
            },
            meetingStatusOptions: ['报名中','已结束'],
            meetingAuditStatusOptions: [
                { label:'待审核', value:0 },
                { label:'审核通过', value:1 },
                { label:'审核不通过', value:2 }
            ],
            continents: [{ label:'亚洲',value:'亚洲' },{ label:'欧洲',value:'欧洲' },{ label:'美洲',value:'美洲' },{ label:'非洲',value:'非洲' },{ label:'中东',value:'中东' },{ label:'大洋洲',value:'大洋洲' }],
            forumList: [],
            innovationList: [],
            innovationMemberList: [],
            memberCenterOptions: [],
            memberCenterOptionsLoading: false,
            countryViewList: [],
            countryList: [],
            countrySidebarPage: 1,
            countrySidebarPageSize: 15,
            countrySidebarTotal: 0,
            countrySidebarLoading: false,
            detail: {},
            countryEditorVisible: false,
            countryFormLoading: false,
            countrySaving: false,
            countryFlagUploading: false,
            countryDeletingId: '',
            cropperModel: { val:false },
            cropperFile: [],
            cropperTarget: '',
            cropperIndex: -1,
            cropperTitle: '裁切图片',
            cropperWidth: 450,
            cropperHeight: 253,
            cropperFixedNumber: [16,9],
            cropperOutputWidth: 654,
            cropperOutputHeight: 230,
            cropperOutputType: 'jpg',
            cropperKey: 0,
            countryForm: createCountryForm(),
            countryRules: {
                name: [{ required:true,message:'请输入国家名称',trigger:'blur' }],
                continent: [{ required:true,message:'请选择所属洲别',trigger:'change' }]
            },
            meetingForm: createMeetingForm(user),
            meetingLeaders: [],
            meetingRules: {
                name: [{ required:true,message:'请输入会议名称',trigger:'blur' }],
                timeRange: [{ type:'array',required:true,message:'请选择活动时间',trigger:'change' }]
            },
            applyForm: createInnovationApplyForm(user),
            applyRules: {
                name: [{ required:true,message:'请输入共创中心名称',trigger:'blur' }],
                founderName: [{ required:true,message:'请输入创始人姓名',trigger:'blur' }],
                contactPhone: [{ required:true,message:'请输入联系电话',trigger:'blur' }]
            },
            items: [{ name:'出海活动数据加载中...' }],
            animate: false
        };
    },
    computed: {
        currentListLength() {
            if (this.currentView === 'activity') return this.forumList.length;
            if (this.currentView === 'cocreate') return this.innovationList.length;
            if (this.currentView === 'member') return this.innovationMemberList.length;
            return this.countryViewList.length;
        },
        emptyDescription() {
            if (this.currentView === 'activity') return '暂无出海活动';
            if (this.currentView === 'cocreate') return '暂无共创中心';
            if (this.currentView === 'member') return '暂无会员';
            return '暂无国家数据';
        },
        deleteConfirmMessage() {
            const fallback=this.deleteConfirmType==='country' ? '该国家' : this.deleteConfirmType==='innovation' ? '该共创中心' : '该出海活动';
            const name=this.deleteConfirmTarget.title || this.deleteConfirmTarget.country || this.deleteConfirmTarget.name || fallback;
            return '确定删除“'+name+'”吗？';
        },
        meetingEnterpriseName() {
            return this.getEnterpriseInfo().name;
        },
        isAuditAdmin() {
            const user=this.getStoredUser();
            return String(localStorage.getItem('acctype') || user.acctype || '')==='3';
        },
        meetingDetailLeaders() {
            return Array.isArray(this.detail.leaders) ? this.detail.leaders : [];
        },
        meetingSignupUsers() {
            if (Array.isArray(this.detail.signup_list)) return this.detail.signup_list;
            if (Array.isArray(this.detail.signup_users)) return this.detail.signup_users;
            return [];
        },
        meetingTicketText() {
            const ticketType=String(this.detail.ticket_type || '').trim();
            if (ticketType) return ticketType;
            return Number(this.detail.price || 0)>0 ? '付费' : '免费';
        },
        meetingPriceText() {
            const price=Number(this.detail.price || 0);
            return price>0 ? '¥'+price : '免费';
        },
        meetingRegisteredCount() {
            return this.meetingSignupUsers.length || Number(this.detail.register_num || 0);
        },
        participantDialogTitle() {
            const title=String(this.participantMeeting.title || this.participantMeeting.name || '').trim();
            return title ? title+' - 参会人员' : '参会人员';
        }
    },
    mounted() {
        this.fetchForums();
        this.fetchSidebarCountries();
        this.timer = setInterval(this.scroll, 2000);
        window.addEventListener('resize', this.calculateTableHeight);
    },
    methods: {
        getStoredUser() {
            try { return JSON.parse(localStorage.getItem('useritem') || '{}') || {}; } catch (error) { return {}; }
        },
        getUserId() {
            const user = this.getStoredUser();
            return String(user.id || user.user_id || localStorage.getItem('id') || localStorage.getItem('userid') || localStorage.getItem('userId') || '').trim();
        },
        getEnterpriseInfo() {
            const user=this.getStoredUser();
            const enterprise=user.enterprise && typeof user.enterprise === 'object' ? user.enterprise : {};
            return {
                id:String(localStorage.getItem('enterprise_id') || enterprise.enterprise_id || enterprise.enterpriseId || enterprise.id || user.enterprise_id || '').trim(),
                name:String(enterprise.enterprise_name || enterprise.enterpriseName || enterprise.name || user.enterprise_name || user.enterpriseName || '').trim()
            };
        },
        unwrap(response) {
            const body = response && response.data ? response.data : response;
            const payload = body && body.data !== undefined ? body.data : body;
            return Array.isArray(payload) ? payload : (payload && Array.isArray(payload.data) ? payload.data : []);
        },
        imageUrl(path, fallback) {
            const value = String(path || '').trim();
            if (!value) return fallback;
            if (/^(https?:|data:|blob:)/i.test(value)) return value;
            if (value.indexOf('/api/') === 0) return value;
            if (value.indexOf('/public/') === 0) return '/api/common/files' + value;
            if (value.indexOf('/') === 0) return '/api/common/files' + value;
            return '/api/common/files/' + value;
        },
        stripHtml(value) { return String(value || '').replace(/<[^>]+>/g,'').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim(); },
        formatDate(value) {
            if (!value) return '';
            const source = String(value).replace('T',' ');
            const date = new Date(source);
            if (Number.isNaN(date.getTime())) return source.slice(0,16);
            const pad = num => String(num).padStart(2,'0');
            return date.getFullYear()+'-'+pad(date.getMonth()+1)+'-'+pad(date.getDate())+' '+pad(date.getHours())+':'+pad(date.getMinutes());
        },
        auditStatusFilter() { return this.isAuditAdmin ? [0,1,2] : [1]; },
        auditStatusText(value) {
            const status=Number(value);
            if (status===0) return '待审核';
            if (status===1) return '审核通过';
            if (status===2) return '审核不通过';
            return '';
        },
        auditStatusClass(value) {
            const status=Number(value);
            if (status===0) return 'audit-status-pending';
            if (status===1) return 'audit-status-approved';
            if (status===2) return 'audit-status-rejected';
            return '';
        },
        normalizeMeeting(item,index) {
            const registered=Number(item.register_num || 0);
            const max=String(item.max_participants || '').trim();
            const count=max ? registered+'/'+max+'人' : registered+'人';
            return { ...item,id:String(item.id || 'meeting-'+index),title:item.name || item.title || '',desc:this.stripHtml(item.description || item.content),cover:this.imageUrl(item.cover_image || item.cover,FORUM_FALLBACK),status:item.status || '',time:item.start_time ? this.formatDate(item.start_time)+(item.end_time ? ' - '+this.formatDate(item.end_time) : '') : item.time,address:item.location || item.address,count,signedUp:Boolean(item.signed_up || item.is_signup) };
        },
        normalizeParticipantGender(value) {
            const text=String(value === undefined || value === null ? '' : value).trim();
            if (text==='1' || text==='男' || /^male$/i.test(text)) return '男';
            if (text==='2' || text==='女' || /^female$/i.test(text)) return '女';
            if (text==='0' || !text) return '--';
            return text;
        },
        normalizeMeetingParticipant(item,index) {
            const user=item && item.user_info && typeof item.user_info === 'object' ? item.user_info : {};
            const profile=item && item.profile && typeof item.profile === 'object' ? item.profile : {};
            const resume=item && item.resume && typeof item.resume === 'object' ? item.resume : {};
            const enterprise=item && item.enterprise && typeof item.enterprise === 'object' ? item.enterprise : {};
            const first=(...values)=>{
                for (const current of values) {
                    if (Array.isArray(current)) {
                        const text=current.filter(value=>value !== undefined && value !== null && String(value).trim()).join('、').trim();
                        if (text) return text;
                    } else if (current !== undefined && current !== null && typeof current !== 'object') {
                        const text=String(current).trim();
                        if (text) return text;
                    }
                }
                return '';
            };
            return {
                id:first(item.id,item.user_id,user.id,index),
                name:first(item.user_name,item.name,user.user_name,user.name,profile.user_name,profile.name) || '--',
                gender:this.normalizeParticipantGender(first(item.gender_name,item.sex_name,item.gender,item.sex,user.gender_name,user.sex_name,user.gender,user.sex,profile.gender_name,profile.sex_name,profile.gender,profile.sex,resume.gender_name,resume.sex_name,resume.gender,resume.sex)),
                phone:first(item.phone,item.mobile,item.mobile_phone,item.phone_number,item.contact_phone,user.phone,user.mobile,user.mobile_phone,user.phone_number,profile.phone,profile.mobile,resume.phone,resume.mobile) || '--',
                company:first(item.enterprise_name,item.enterprise,item.company_name,item.company,enterprise.enterprise_name,enterprise.company_name,enterprise.name,user.enterprise_name,user.company_name,profile.enterprise_name,profile.company_name,resume.enterprise_name,resume.company_name,resume.company) || '--',
                position:first(item.position_name,item.position,item.job_title,item.job_position,item.title_name,item.user_title_name,user.position_name,user.position,user.job_title,user.title_name,profile.position_name,profile.position,profile.job_title,profile.title_name,resume.position_name,resume.position,resume.job_title,resume.job_positions) || '--'
            };
        },
        normalizeInnovation(item,index) {
            const leaders = Array.isArray(item.leaders) ? item.leaders : [];
            const leader = leaders[0] || {};
            return { ...item,id:String(item.id || 'innovation-'+index),title:item.name || '',owner:leader.name || item.enterprise_name || '',desc:this.stripHtml(item.description),cover:this.imageUrl(item.cover_image || leader.avatar,MEMBER_FALLBACK),count:Number(item.member_count || 0)+'人',joined:item.joined === true || item.joined === 1 || String(item.joined).toLowerCase() === 'true' };
        },
        normalizeInnovationMember(item,index) {
            return { ...item,id:String(item.id || 'innovation-member-'+index),userId:String(item.user_id || ''),name:item.user_name || '会员',centerName:item.center_name || '共创中心会员',avatar:this.imageUrl(item.user_avatar,MEMBER_FALLBACK) };
        },
        formatFollow(value) {
            const count = Number(value || 0);
            if (count >= 10000) return (count / 10000).toFixed(count % 10000 ? 1 : 0).replace(/\.0$/,'')+'万人';
            return count+'人';
        },
        normalizeCountry(item,index) {
            const country = String(item.name || item.country_name || item.country || '').trim();
            return { ...item,id:String(item.id || 'country-'+index),country,title:item.embassy_info || item.title || (country ? country+'出海服务' : ''),desc:this.stripHtml(item.description || item.embassy_info),resource:item.resource_specialty || item.resource || item.specialty,address:item.address || '',trade:item.import_export_amount || item.trade,follow:this.formatFollow(item.follow_count || item.follow),cover:this.imageUrl(item.flag_image || item.cover_image || item.cover,MEMBER_FALLBACK) };
        },
        async switchOverseasView(view) {
            this.currentView = view;
            if (view === 'activity' && !this.forumList.length) await this.fetchForums();
            if (view === 'cocreate' && !this.innovationList.length) await this.fetchInnovations();
            if (view === 'member') {
                const tasks=[];
                if (!this.innovationMemberList.length) tasks.push(this.fetchInnovationMembers());
                if (!this.memberCenterOptions.length) tasks.push(this.fetchMemberCenterOptions());
                if (tasks.length) await Promise.all(tasks);
            }
        },
        async fetchForums() {
            this.loading = true;
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appMeetingList,{ data:{
                    page:1,
                    limit:20,
                    status:String(this.formInline.meetingStatus || '').trim() || undefined,
                    audit_status:this.auditStatusFilter()
                } });
                this.forumList = response && response.data && Number(response.data.code) === 0 ? this.unwrap(response).map((item,index)=>this.normalizeMeeting(item,index)) : [];
                this.items = [{ name:this.forumList.length ? '共加载 '+this.forumList.length+' 条出海活动' : '暂无出海活动' }];
            } catch (error) { this.forumList = []; } finally { this.loading = false; }
        },
        async fetchInnovations() {
            this.loading = true;
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appInnovationList,{ data:{
                    page:1,
                    limit:20,
                    name:String(this.formInline.innovationName || '').trim() || undefined,
                    audit_status:this.auditStatusFilter()
                } });
                this.innovationList = response && response.data && Number(response.data.code) === 0 ? this.unwrap(response).map((item,index)=>this.normalizeInnovation(item,index)) : [];
            } catch (error) { this.innovationList = []; } finally { this.loading = false; }
        },
        async fetchInnovationMembers() {
            this.loading = true;
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appInnovationListMember,{ data:{
                    page:1,
                    limit:20,
                    keyword:String(this.formInline.memberKeyword || '').trim() || undefined,
                    center_id:String(this.formInline.memberCenterId || '').trim() || undefined
                } });
                this.innovationMemberList = response && response.data && Number(response.data.code) === 0 ? this.unwrap(response).map((item,index)=>this.normalizeInnovationMember(item,index)) : [];
            } catch (error) { this.innovationMemberList = []; } finally { this.loading = false; }
        },
        async fetchMemberCenterOptions() {
            this.memberCenterOptionsLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appInnovationList,{ data:{ page:1,limit:100,audit_status:[1] } });
                this.memberCenterOptions=response && response.data && Number(response.data.code)===0
                    ? this.unwrap(response).map(item=>({ id:String(item.id || '').trim(),name:String(item.name || '').trim() })).filter(item=>item.id && item.name)
                    : [];
            } catch (error) { this.memberCenterOptions=[]; } finally { this.memberCenterOptionsLoading=false; }
        },
        async fetchSidebarCountries(page=this.countrySidebarPage) {
            this.countrySidebarPage=Number(page) || 1;
            this.countrySidebarLoading=true;
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appCountryList,{ data:{ page:this.countrySidebarPage,limit:this.countrySidebarPageSize } });
                this.countryList = response && response.data && Number(response.data.code) === 0 ? this.unwrap(response).map((item,index)=>this.normalizeCountry(item,index)) : [];
                const payload=response && response.data ? response.data.data : null;
                this.countrySidebarTotal=Number(payload && payload.total || response && response.data && response.data.total || 0);
            } catch (error) { this.countryList = [];this.countrySidebarTotal=0; }
            finally { this.countrySidebarLoading=false; }
        },
        handleCountrySidebarPageChange(page) { this.fetchSidebarCountries(page); },
        async fetchCountries() {
            this.loading = true;
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appCountryList,{ data:{ page:1,limit:20,continent:this.formInline.continent || undefined } });
                this.countryViewList = response && response.data && Number(response.data.code) === 0 ? this.unwrap(response).map((item,index)=>this.normalizeCountry(item,index)) : [];
            } catch (error) { this.countryViewList = []; } finally { this.loading = false; }
        },
        selectContinent() { this.currentView='country'; this.fetchCountries(); },
        refreshList() {
            if (this.currentView === 'activity') return this.fetchForums();
            if (this.currentView === 'cocreate') return this.fetchInnovations();
            if (this.currentView === 'member') return this.fetchInnovationMembers();
            return this.fetchCountries();
        },
        clearItem() {
            if (this.currentView === 'activity') this.formInline.meetingStatus='';
            else if (this.currentView === 'cocreate') this.formInline.innovationName='';
            else if (this.currentView === 'member') {
                this.formInline.memberKeyword='';
                this.formInline.memberCenterId='';
            } else this.formInline.continent='';
            return this.refreshList();
        },
        deleteMeeting(item) {
            if (!this.isAuditAdmin || !item || !item.id || this.meetingDeletingId) return;
            this.deleteConfirmType='meeting';
            this.deleteConfirmTarget={ ...item };
            this.deleteConfirmVisible=true;
        },
        deleteInnovation(item) {
            if (!this.isAuditAdmin || !item || !item.id || this.innovationDeletingId) return;
            this.deleteConfirmType='innovation';
            this.deleteConfirmTarget={ ...item };
            this.deleteConfirmVisible=true;
        },
        resetDeleteConfirm() {
            this.deleteConfirmType='';
            this.deleteConfirmTarget={};
        },
        async confirmDelete() {
            if (this.deleteConfirmLoading) return;
            const type=this.deleteConfirmType;
            const item={ ...this.deleteConfirmTarget };
            if (!item.id || !['meeting','innovation','country'].includes(type)) return;
            if (!this.isAuditAdmin) return;
            this.deleteConfirmLoading=true;
            if (type==='meeting') this.meetingDeletingId=String(item.id);
            else if (type==='innovation') this.innovationDeletingId=String(item.id);
            else this.countryDeletingId=String(item.id);
            try {
                const url=type==='meeting' ? this.$baseUrl.appMeetingDel : type==='innovation' ? this.$baseUrl.appInnovationDel : this.$baseUrl.appCountryDel;
                const payload=type==='innovation' ? { ids:[item.id] } : { id:item.id };
                const response=await this.$tools.asyncPost(this,url,{ data:payload });
                if (response && response.data && Number(response.data.code)===0) {
                    if (this.detail.type===type && String(this.detail.id)===String(item.id)) this.detailVisible=false;
                    if (type==='meeting') await this.fetchForums();
                    else if (type==='innovation') await this.fetchInnovations();
                    else await this.refreshCountryData();
                    this.deleteConfirmVisible=false;
                    this.$message.success(response.data.msg || '删除成功');
                } else {
                    this.$message.error(response && response.data && response.data.msg || '删除失败');
                }
            } catch (error) {
                this.$message.error(error.message || '删除失败，请稍后重试');
            } finally {
                this.deleteConfirmLoading=false;
                this.meetingDeletingId='';
                this.innovationDeletingId='';
                this.countryDeletingId='';
                if (!this.deleteConfirmVisible) this.resetDeleteConfirm();
            }
        },
        openAuditDialog(type,item) {
            if (!this.isAuditAdmin || !item || !item.id) return;
            this.auditTarget={ ...item,type,title:item.title || item.name || '--' };
            this.auditForm={ status:Number(item.audit_status)===2 ? 2 : 1,remark:String(item.audit_remark || '').trim() };
            this.auditVisible=true;
            this.$nextTick(()=>{
                if (this.$refs.auditForm) this.$refs.auditForm.clearValidate();
            });
        },
        resetAuditForm() {
            this.auditTarget={};
            this.auditForm={ status:1,remark:'' };
            this.$nextTick(()=>{
                if (this.$refs.auditForm) this.$refs.auditForm.clearValidate();
            });
        },
        submitAudit() {
            if (!this.isAuditAdmin || this.auditSubmitting) return;
            this.$refs.auditForm.validate(async valid=>{
                if (!valid || !this.auditTarget.id) return;
                const user=this.getStoredUser();
                const type=this.auditTarget.type;
                const url=type==='meeting' ? this.$baseUrl.appMeetingAudit : this.$baseUrl.appInnovationAudit;
                this.auditSubmitting=true;
                try {
                    const response=await this.$tools.asyncPost(this,url,{ data:{
                        id:this.auditTarget.id,
                        status:Number(this.auditForm.status),
                        remark:String(this.auditForm.remark || '').trim(),
                        auditor_id:this.getUserId(),
                        auditor_name:String(user.name || user.real_name || user.user_name || user.uname || '').trim()
                    } });
                    if (response && response.data && Number(response.data.code)===0) {
                        this.auditVisible=false;
                        if (type==='meeting') await this.fetchForums(); else await this.fetchInnovations();
                        this.$message.success(response.data.msg || '审核成功');
                    } else {
                        this.$message.error(response && response.data && response.data.msg || '审核失败');
                    }
                } catch (error) { this.$message.error(error.message || '审核失败，请稍后重试'); } finally { this.auditSubmitting=false; }
            });
        },
        fillCountryForm(item) {
            const source=item || {};
            this.countryForm={
                id:String(source.id || '').trim(),
                name:String(source.name || source.country || '').trim(),
                flagImage:String(source.flag_image || source.flagImage || '').trim(),
                flagPreview:this.imageUrl(source.flag_image || source.flagImage || '', ''),
                continent:String(source.continent || '').trim(),
                importExportAmount:String(source.import_export_amount || source.importExportAmount || '').trim(),
                embassyInfo:String(source.embassy_info || source.embassyInfo || '').trim(),
                address:String(source.address || '').trim(),
                resourceSpecialty:String(source.resource_specialty || source.resourceSpecialty || '').trim(),
                description:String(source.description || '').trim()
            };
        },
        resetCountryForm() {
            this.countryForm=createCountryForm();
            this.countryFormLoading=false;
            this.countryFlagUploading=false;
            this.$nextTick(()=>{
                if (this.$refs.countryForm) this.$refs.countryForm.clearValidate();
            });
        },
        async openCountryEditor(item) {
            if (!this.isAuditAdmin) return;
            this.resetCountryForm();
            this.countryEditorVisible=true;
            if (!item || !item.id) return;
            this.countryFormLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appCountryGet,{ data:{ id:item.id } });
                if (response && response.data && Number(response.data.code)===0) this.fillCountryForm({ ...item,...(response.data.data || {}) });
                else this.fillCountryForm(item);
            } catch (error) {
                this.fillCountryForm(item);
                this.$message.error('国家信息加载失败，请稍后重试');
            } finally { this.countryFormLoading=false; }
        },
        handleCountryFlagChange(file,fileList) {
            this.openImageCropper(file,fileList,'country');
        },
        async refreshCountryData() {
            const tasks=[this.fetchSidebarCountries()];
            if (this.currentView==='country') tasks.push(this.fetchCountries());
            await Promise.all(tasks);
        },
        saveCountry() {
            if (!this.isAuditAdmin) return;
            this.$refs.countryForm.validate(async valid=>{
                if (!valid || this.countrySaving) return;
                if (this.countryFlagUploading) return this.$message.warning('国旗图片正在上传，请稍候');
                const editing=Boolean(this.countryForm.id);
                const payload={
                    name:String(this.countryForm.name || '').trim(),
                    flag_image:this.countryForm.flagImage || '',
                    continent:String(this.countryForm.continent || '').trim(),
                    import_export_amount:String(this.countryForm.importExportAmount || '').trim(),
                    embassy_info:String(this.countryForm.embassyInfo || '').trim(),
                    address:String(this.countryForm.address || '').trim(),
                    resource_specialty:String(this.countryForm.resourceSpecialty || '').trim(),
                    description:String(this.countryForm.description || '').trim()
                };
                if (editing) payload.id=this.countryForm.id;
                this.countrySaving=true;
                try {
                    const url=editing ? this.$baseUrl.appCountryEdit : this.$baseUrl.appCountryAdd;
                    const response=await this.$tools.asyncPost(this,url,{ data:payload });
                    if (response && response.data && Number(response.data.code)===0) {
                        this.countryEditorVisible=false;
                        await this.refreshCountryData();
                        this.$message.success(response.data.msg || (editing ? '编辑成功' : '新增成功'));
                    } else {
                        this.$message.error(response && response.data && response.data.msg || '保存失败');
                    }
                } catch (error) { this.$message.error(error.message || '保存失败，请稍后重试'); } finally { this.countrySaving=false; }
            });
        },
        deleteCountry(item) {
            if (!this.isAuditAdmin || !item || !item.id || this.countryDeletingId) return;
            this.deleteConfirmType='country';
            this.deleteConfirmTarget={ ...item };
            this.deleteConfirmVisible=true;
        },
        async openMeeting(item) {
            this.meetingActionMessage='';
            this.meetingActionMessageType='error';
            this.detailVisible=true; this.detailTitle='活动详情'; this.detailLoading=true; this.detail={ ...item,type:'meeting' };
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appMeetingGet,{ data:{ id:item.id } });
                if (response && response.data && Number(response.data.code) === 0) {
                    const meetingData={ ...item,...(response.data.data || {}) };
                    this.detail={ ...meetingData,...this.normalizeMeeting(meetingData,0),type:'meeting' };
                }
                const userId = this.getUserId();
                if (userId) {
                    try {
                        const signup = await this.$tools.asyncPost(this,this.$baseUrl.appMeetingGetSignupInfo,{ data:{ meeting_id:item.id,user_id:userId } },{ suppressBusinessErrorMessage:true });
                        this.detail.signedUp = Boolean(signup && signup.data && Number(signup.data.code) === 0 && signup.data.data);
                    } catch (error) {
                        this.meetingActionMessage=error.message || '报名状态查询失败';
                        this.meetingActionMessageType='error';
                    }
                }
            } catch (error) {} finally { this.detailLoading=false; }
        },
        async openMeetingParticipants(item) {
            if (!item || !item.id) return;
            this.participantMeeting={ ...item };
            this.participantList=[];
            this.participantVisible=true;
            this.participantLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appMeetingGet,{ data:{ id:item.id } });
                if (!response || !response.data || Number(response.data.code)!==0) {
                    this.$message.error(response && response.data && response.data.msg || '参会人员获取失败');
                    return;
                }
                const data=response.data.data || {};
                const signupList=Array.isArray(data.signup_list) ? data.signup_list : (Array.isArray(data.signup_users) ? data.signup_users : []);
                this.participantMeeting={ ...item,...data };
                this.participantList=signupList.map((user,index)=>this.normalizeMeetingParticipant(user,index));
            } catch (error) {
                this.$message.error(error.message || '参会人员获取失败，请稍后重试');
            } finally {
                this.participantLoading=false;
            }
        },
        escapeXml(value) {
            return String(value === undefined || value === null ? '' : value)
                .replace(/&/g,'&amp;')
                .replace(/</g,'&lt;')
                .replace(/>/g,'&gt;')
                .replace(/"/g,'&quot;')
                .replace(/'/g,'&apos;');
        },
        exportMeetingParticipants() {
            if (!this.participantList.length) return;
            const headers=['姓名','性别','手机号码','所属公司','职位'];
            const rows=this.participantList.map(item=>[item.name,item.gender,item.phone,item.company,item.position]);
            const rowXml=[headers,...rows].map((row,rowIndex)=>'<Row>'+row.map(value=>'<Cell ss:StyleID="'+(rowIndex===0 ? 'Header' : 'Text')+'"><Data ss:Type="String">'+this.escapeXml(value)+'</Data></Cell>').join('')+'</Row>').join('');
            const excelXml='<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?>'+
                '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">'+
                '<Styles><Style ss:ID="Header"><Font ss:Bold="1"/><Alignment ss:Vertical="Center"/></Style><Style ss:ID="Text"><NumberFormat ss:Format="@"/><Alignment ss:Vertical="Center"/></Style></Styles>'+
                '<Worksheet ss:Name="参会人员"><Table>'+
                '<Column ss:AutoFitWidth="0" ss:Width="100"/><Column ss:AutoFitWidth="0" ss:Width="70"/><Column ss:AutoFitWidth="0" ss:Width="140"/><Column ss:AutoFitWidth="0" ss:Width="200"/><Column ss:AutoFitWidth="0" ss:Width="140"/>'+
                rowXml+'</Table></Worksheet></Workbook>';
            const blob=new Blob(['\ufeff'+excelXml],{ type:'application/vnd.ms-excel;charset=utf-8;' });
            const link=document.createElement('a');
            const title=String(this.participantMeeting.title || this.participantMeeting.name || '活动').replace(/[\\/:*?"<>|]/g,'_');
            link.href=URL.createObjectURL(blob);
            link.download=title+'-参会人员列表.xls';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        },
        async openInnovation(item) {
            this.detailVisible=true; this.detailTitle='共创中心详情'; this.detailLoading=true; this.detail={ ...item,type:'innovation' };
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appInnovationGet,{ data:{ id:item.id,user_id:this.getUserId() || undefined } });
                if (response && response.data && Number(response.data.code) === 0) this.detail={ ...item,...this.normalizeInnovation(response.data.data || {},0),type:'innovation' };
            } catch (error) {} finally { this.detailLoading=false; }
        },
        async openInnovationEditor(item) {
            if (!this.isAuditAdmin || !item || !item.id) return;
            this.resetApplyDialog();
            this.applyMode='create';
            this.applyView='form';
            this.applyTarget={ ...item };
            this.innovationEditing=true;
            this.applyVisible=true;
            this.innovationEditorLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appInnovationGet,{ data:{ id:item.id,user_id:this.getUserId() || undefined } });
                const source=response && response.data && Number(response.data.code)===0 ? (response.data.data || {}) : item;
                const leader=Array.isArray(source.leaders) && source.leaders.length ? source.leaders[0] : {};
                const cover=source.cover_image || source.cover || item.cover_image || item.cover || '';
                this.applyForm={
                    ...createInnovationApplyForm(this.getStoredUser()),
                    name:String(source.name || source.title || item.title || '').trim(),
                    founderName:String(leader.name || source.founder_name || item.owner || '').trim(),
                    founderId:String(leader.id || '').trim(),
                    founderAvatar:String(leader.avatar || '').trim(),
                    contactPhone:String(source.contact_phone || source.contactPhone || '').trim(),
                    address:String(source.address || '').trim(),
                    description:String(source.description || item.description || item.desc || '').trim(),
                    coverImage:String(cover).trim(),
                    coverPreview:this.imageUrl(cover,MEMBER_FALLBACK),
                    coverFile:null,
                    coverUploading:false,
                    remark:''
                };
            } catch (error) {
                this.applyForm={
                    ...createInnovationApplyForm(this.getStoredUser()),
                    name:String(item.name || item.title || '').trim(),
                    founderName:String(item.owner || '').trim(),
                    founderId:'',
                    founderAvatar:'',
                    contactPhone:String(item.contact_phone || item.contactPhone || '').trim(),
                    address:String(item.address || '').trim(),
                    description:String(item.description || item.desc || '').trim(),
                    coverImage:String(item.cover_image || item.cover || '').trim(),
                    coverPreview:this.imageUrl(item.cover_image || item.cover,MEMBER_FALLBACK),
                    coverFile:null,
                    coverUploading:false,
                    remark:''
                };
                this.$message.warning('共创中心详情获取失败，已使用列表信息');
            } finally {
                this.innovationEditorLoading=false;
            }
            this.$nextTick(()=>{ if (this.$refs.applyForm) this.$refs.applyForm.clearValidate(); });
        },
        async openCountry(item) {
            this.detailVisible=true; this.detailTitle='国家详情'; this.detailLoading=true; this.detail={ ...item,type:'country' };
            try {
                const response = await this.$tools.asyncPost(this,this.$baseUrl.appCountryGet,{ data:{ id:item.id } });
                if (response && response.data && Number(response.data.code) === 0) {
                    const countryData={ ...item,...(response.data.data || {}) };
                    this.detail={ ...countryData,...this.normalizeCountry(countryData,0),type:'country' };
                }
            } catch (error) {} finally { this.detailLoading=false; }
        },
        openMemberChat(item) {
            this.$router.push({ path:'/index/mymessage',query:{ peerId:item.userId,peerName:item.name,sceneType:'innovation',roomId:item.center_id || '' } });
        },
        openMeetingPublish() {
            const enterprise=this.getEnterpriseInfo();
            if (!this.getUserId()) return this.$message.warning('请先登录');
            if (!enterprise.id) return this.$message.warning('企业信息缺失');
            this.resetMeetingPublish();
            this.meetingPublishVisible=true;
        },
        async openMeetingEditor(item) {
            if (!this.isAuditAdmin || !item || !item.id) return;
            const enterprise=this.getEnterpriseInfo();
            if (!this.getUserId()) return this.$message.warning('请先登录');
            if (!enterprise.id) return this.$message.warning('企业信息缺失');
            this.resetMeetingPublish();
            this.meetingEditing=true;
            this.meetingEditId=String(item.id);
            this.meetingPublishVisible=true;
            this.meetingFormLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appMeetingGet,{ data:{ id:item.id } });
                const source=response && response.data && Number(response.data.code)===0
                    ? (response.data.data || {})
                    : item;
                if (response && response.data && Number(response.data.code)!==0) {
                    this.$message.error(response.data.msg || '活动信息加载失败');
                }
                const start=this.parseMeetingDate(source.start_time || source.startTime);
                const end=this.parseMeetingDate(source.end_time || source.endTime);
                const cover=source.cover_image || source.cover || item.cover_image || item.cover || '';
                this.meetingForm={
                    ...createMeetingForm(this.getStoredUser()),
                    name:String(source.name || source.title || item.title || '').trim(),
                    content:String(source.content || '').trim(),
                    timeRange:start && end ? [start,end] : this.meetingForm.timeRange,
                    location:String(source.location || source.address || '').trim(),
                    contactPerson:String(source.contact_person || source.contactPerson || '').trim(),
                    contactPhone:String(source.contact_phone || source.contactPhone || '').trim(),
                    maxParticipants:Number(source.max_participants ?? source.maxParticipants ?? 0),
                    price:Number(source.price || 0),
                    auditStatus:[0,1,2].includes(Number(source.audit_status ?? source.auditStatus)) ? Number(source.audit_status ?? source.auditStatus) : 0,
                    coverImage:String(cover).trim(),
                    coverFile:null,
                    coverPreview:this.imageUrl(cover,FORUM_FALLBACK),
                    description:String(source.description || item.description || item.desc || '').trim(),
                    coHostEnterpriseId:String(source.co_host_enterprise_id || source.coHostEnterpriseId || '').trim(),
                    coHostEnterpriseName:String(source.co_host_enterprise_name || source.coHostEnterpriseName || '').trim()
                };
                const sourceLeaders=Array.isArray(source.leaders) ? source.leaders : [];
                this.meetingLeaders=sourceLeaders.map(leader=>({
                    key:++this.meetingLeaderKey,
                    name:String(leader.name || '').trim(),
                    avatar:String(leader.avatar || '').trim(),
                    avatarPreview:this.imageUrl(leader.avatar,'/static/global/overseas-member-cover.png'),
                    description:String(leader.description || '').trim(),
                    attendTime:this.parseMeetingDate(leader.attend_time || leader.attendTime) || (this.meetingForm.timeRange[0] ? new Date(this.meetingForm.timeRange[0]) : new Date()),
                    uploading:false
                }));
            } catch (error) {
                this.$message.error(error.message || '活动信息加载失败，请稍后重试');
            } finally {
                this.meetingFormLoading=false;
            }
            this.$nextTick(()=>{ if (this.$refs.meetingPublishForm) this.$refs.meetingPublishForm.clearValidate(); });
        },
        parseMeetingDate(value) {
            if (!value) return null;
            const date=new Date(String(value).replace(' ','T'));
            return Number.isNaN(date.getTime()) ? null : date;
        },
        resetMeetingPublish() {
            if (this.meetingForm.coverPreview && /^blob:/i.test(this.meetingForm.coverPreview)) URL.revokeObjectURL(this.meetingForm.coverPreview);
            this.meetingForm=createMeetingForm(this.getStoredUser());
            this.meetingLeaders=[];
            this.meetingLeaderKey=0;
            this.meetingEditing=false;
            this.meetingEditId='';
            this.meetingFormLoading=false;
            this.meetingCoverUploading=false;
            this.$nextTick(()=>{
                if (this.$refs.meetingPublishForm) this.$refs.meetingPublishForm.clearValidate();
            });
        },
        addMeetingLeader() {
            const timeRange=this.meetingForm.timeRange || [];
            this.meetingLeaders.push({
                key:++this.meetingLeaderKey,name:'',avatar:'',avatarPreview:'',description:'',
                attendTime:timeRange[0] ? new Date(timeRange[0]) : new Date(),uploading:false
            });
        },
        removeMeetingLeader(index) { this.meetingLeaders.splice(index,1); },
        async uploadMeetingImage(file,folder='initiative') {
            const storedToken=String(localStorage.getItem('token') || localStorage.getItem('TOKEN') || '').trim();
            const rawToken=storedToken.replace(/^Bearer\s+/i,'');
            const formData=new FormData();
            formData.append('file',file,file.name || 'image.jpg');
            formData.append('rename','0');
            const response=await this.$axios.post(this.$baseUrl.filesupload+'/public/global/'+folder+'?rename=0',formData,{
                headers:{
                    Token:rawToken ? 'Bearer '+rawToken : '',
                    token:rawToken,
                    'content-type':'multipart/form-data'
                },
                timeout:30000
            });
            if (!response || !response.data || Number(response.data.code)!==0) throw new Error(response && response.data && response.data.msg || '图片上传失败');
            const files=Array.isArray(response.data.data) ? response.data.data : [response.data.data];
            const uploaded=files[files.length-1] || {};
            const path=String(uploaded.upload_path || uploaded.file_path || uploaded.url || uploaded.path || uploaded || '').trim();
            if (!path) throw new Error('图片上传失败');
            return path;
        },
        openImageCropper(file,fileList,target,index=-1) {
            const raw=file && (file.raw || file);
            if (!raw) return;
            if (!String(raw.type || '').toLowerCase().startsWith('image/')) {
                if (Array.isArray(fileList)) fileList.splice(fileList.indexOf(file),1);
                return this.$message.error('仅支持图片格式');
            }
            if (Number(raw.size || 0)>10*1024*1024) {
                if (Array.isArray(fileList)) fileList.splice(fileList.indexOf(file),1);
                return this.$message.error('图片大小不能超过10MB');
            }
            const titleMap={
                innovation:'裁切共创中心封面',
                country:'裁切国家图片',
                meeting:'裁切活动封面',
                leader:'裁切领导头像'
            };
            const cropConfig={
                innovation:{ width:460,height:300,fixedNumber:[23,15],outputWidth:230,outputHeight:150,outputType:'jpg' },
                country:{ width:288,height:192,fixedNumber:[3,2],outputWidth:288,outputHeight:192,outputType:'jpg' },
                meeting:{ width:490,height:225,fixedNumber:[710,326],outputWidth:710,outputHeight:326,outputType:'jpg' },
                leader:{ width:300,height:300,fixedNumber:[1,1],outputWidth:720,outputHeight:720,outputType:'png' }
            };
            const config=cropConfig[target] || cropConfig.meeting;
            const sourceUrl=file.url || URL.createObjectURL(raw);
            this.resetCropper();
            this.cropperTarget=target;
            this.cropperIndex=index;
            this.cropperTitle=titleMap[target] || '裁切图片';
            this.cropperWidth=config.width;
            this.cropperHeight=config.height;
            this.cropperFixedNumber=config.fixedNumber;
            this.cropperOutputWidth=config.outputWidth;
            this.cropperOutputHeight=config.outputHeight;
            this.cropperOutputType=config.outputType;
            this.cropperFile=[{ ...file,raw,url:sourceUrl,__cropperObjectUrl:!file.url }];
            this.cropperKey+=1;
            this.cropperModel.val=true;
        },
        resetCropper() {
            const source=this.cropperFile[this.cropperFile.length-1];
            if (source && source.__cropperObjectUrl && /^blob:/i.test(source.url || '')) URL.revokeObjectURL(source.url);
            this.cropperFile=[];
            this.cropperTarget='';
            this.cropperIndex=-1;
        },
        dataUrlToFile(dataUrl,name) {
            const parts=String(dataUrl || '').split(',');
            const mimeMatch=(parts[0] || '').match(/:(.*?);/);
            const mime=mimeMatch ? mimeMatch[1] : 'image/jpeg';
            const binary=atob(parts[1] || '');
            const bytes=new Uint8Array(binary.length);
            for (let index=0;index<binary.length;index+=1) bytes[index]=binary.charCodeAt(index);
            return new File([bytes],name,{ type:mime });
        },
        async handleCroppedImage(dataUrl) {
            const target=this.cropperTarget;
            const leaderIndex=this.cropperIndex;
            const extension=this.cropperOutputType==='png' ? 'png' : 'jpg';
            const croppedFile=this.dataUrlToFile(dataUrl,target+'-'+Date.now()+'.'+extension);
            if (target==='meeting') {
                this.meetingForm.coverFile=croppedFile;
                this.meetingForm.coverImage='';
                this.meetingForm.coverPreview=dataUrl;
                return;
            }
            if (target==='innovation') {
                this.applyForm.coverFile=croppedFile;
                this.applyForm.coverImage='';
                this.applyForm.coverPreview=dataUrl;
                return;
            }
            if (target==='country') {
                const oldImage=this.countryForm.flagImage;
                const oldPreview=this.countryForm.flagPreview;
                this.countryFlagUploading=true;
                this.countryForm.flagPreview=dataUrl;
                try {
                    this.countryForm.flagImage=await this.uploadMeetingImage(croppedFile,'country');
                } catch (error) {
                    this.countryForm.flagImage=oldImage;
                    this.countryForm.flagPreview=oldPreview;
                    this.$message.error(error.message || '国家图片上传失败');
                } finally { this.countryFlagUploading=false; }
                return;
            }
            if (target==='leader') {
                const leader=this.meetingLeaders[leaderIndex];
                if (!leader) return;
                const oldAvatar=leader.avatar;
                const oldPreview=leader.avatarPreview;
                leader.uploading=true;
                leader.avatarPreview=dataUrl;
                try {
                    leader.avatar=await this.uploadMeetingImage(croppedFile);
                } catch (error) {
                    leader.avatar=oldAvatar;
                    leader.avatarPreview=oldPreview;
                    this.$message.error(error.message || '领导头像上传失败');
                } finally { leader.uploading=false; }
            }
        },
        handleMeetingCoverChange(file,fileList) {
            this.openImageCropper(file,fileList,'meeting');
        },
        handleLeaderAvatarChange(file,fileList,index) {
            this.openImageCropper(file,fileList,'leader',index);
        },
        submitMeetingPublish() {
            this.$refs.meetingPublishForm.validate(async valid=>{
                if (!valid || this.meetingPublishing || this.meetingFormLoading) return;
                if (this.meetingCoverUploading || this.meetingLeaders.some(item=>item.uploading)) return this.$message.warning('图片正在上传，请稍候');
                const timeRange=this.meetingForm.timeRange || [];
                const start=new Date(timeRange[0]);
                const end=new Date(timeRange[1]);
                if (!start.getTime() || !end.getTime()) return this.$message.warning('请选择活动时间');
                if (end.getTime()<=start.getTime()) return this.$message.warning('结束时间必须晚于开始时间');
                const enterprise=this.getEnterpriseInfo();
                if (!enterprise.id) return this.$message.warning('企业信息缺失');
                const leaders=this.meetingLeaders.filter(item=>String(item.name || '').trim()).map(item=>({
                    name:String(item.name).trim(),avatar:item.avatar || '',description:String(item.description || '').trim(),
                    attend_time:item.attendTime ? this.formatDate(item.attendTime) : ''
                }));
                this.meetingPublishing=true;
                try {
                    const coverImage=this.meetingForm.coverFile
                        ? await this.uploadMeetingImage(this.meetingForm.coverFile)
                        : this.meetingForm.coverImage || '';
                    const response=await this.$tools.asyncPost(this,this.meetingEditing ? this.$baseUrl.appMeetingEdit : this.$baseUrl.appMeetingAdd,{ data:{
                        ...(this.meetingEditing ? { id:this.meetingEditId } : {}),
                        name:String(this.meetingForm.name || '').trim(),content:String(this.meetingForm.content || '').trim(),
                        start_time:start.toISOString(),end_time:end.toISOString(),location:String(this.meetingForm.location || '').trim(),
                        contact_person:String(this.meetingForm.contactPerson || '').trim(),contact_phone:String(this.meetingForm.contactPhone || '').trim(),
                        max_participants:Number(this.meetingForm.maxParticipants || 0),price:Number(this.meetingForm.price || 0),
                        ...(this.meetingEditing ? { audit_status:Number(this.meetingForm.auditStatus) } : {}),
                        cover_image:coverImage,description:String(this.meetingForm.description || '').trim(),
                        enterprise_id:enterprise.id,enterprise_name:enterprise.name,
                        co_host_enterprise_id:String(this.meetingForm.coHostEnterpriseId || '').trim(),
                        co_host_enterprise_name:String(this.meetingForm.coHostEnterpriseName || '').trim(),leaders
                    } });
                    if (response && response.data && Number(response.data.code)===0) {
                        this.meetingPublishVisible=false;
                        this.currentView='activity';
                        await this.fetchForums();
                        this.$message.success(response.data.msg || (this.meetingEditing ? '保存成功' : '发布成功'));
                    } else {
                        this.$message.error(response && response.data && response.data.msg || (this.meetingEditing ? '保存失败' : '发布失败'));
                    }
                } catch (error) { this.$message.error(error.message || (this.meetingEditing ? '保存失败，请稍后重试' : '发布失败，请稍后重试')); } finally { this.meetingPublishing=false; }
            });
        },
        openApplyDialog() {
            this.resetApplyDialog();
            this.applyMode='create';
            this.applyView='form';
            this.applyVisible=true;
        },
        openInnovationJoinDialog() {
            if (!this.getUserId()) return this.$message.warning('请先登录');
            this.resetApplyDialog();
            this.applyMode='join';
            this.applyTarget={ ...this.detail,title:this.detail.title || this.detail.name || '--' };
            this.applyVisible=true;
        },
        resetApplyDialog() {
            if (this.applyForm.coverPreview && /^blob:/i.test(this.applyForm.coverPreview)) URL.revokeObjectURL(this.applyForm.coverPreview);
            this.applyMode='create';
            this.applyView='form';
            this.applyTarget={};
            this.innovationEditing=false;
            this.innovationEditorLoading=false;
            this.applyForm=createInnovationApplyForm(this.getStoredUser());
            this.$nextTick(()=>{
                if (this.$refs.applyForm) this.$refs.applyForm.clearValidate();
            });
        },
        handleApplyTabClick(tab) {
            if (tab && tab.name==='records' && !this.applicationRecordsLoaded) this.fetchApplicationRecords();
        },
        normalizeApplicationRecord(item,index) {
            const record=this.normalizeInnovation(item,index);
            return {
                ...record,
                applyTime:String(item.ctime_str || item.ctime || item.create_time || '').replace('T',' ').slice(0,10) || '--',
                auditRemark:String(item.audit_remark || item.audit_reason || item.reason || item.remark || '').trim() || '--'
            };
        },
        async fetchApplicationRecords() {
            const userId=this.getUserId();
            if (!userId) {
                this.applicationRecords=[];
                return this.$message.warning('请先登录');
            }
            this.applicationRecordsLoading=true;
            try {
                const response=await this.$tools.asyncPost(this,this.$baseUrl.appInnovationList,{ data:{ page:1,limit:50 } });
                if (!response || !response.data || Number(response.data.code)!==0) throw new Error(response && response.data && response.data.msg || '申请记录获取失败');
                this.applicationRecords=this.unwrap(response).map((item,index)=>this.normalizeApplicationRecord(item,index));
                this.applicationRecordsLoaded=true;
            } catch (error) {
                this.applicationRecords=[];
                this.$message.error(error.message || '申请记录获取失败');
            } finally { this.applicationRecordsLoading=false; }
        },
        handleInnovationCoverChange(file,fileList) {
            this.openImageCropper(file,fileList,'innovation');
        },
        submitApply() {
            if (this.actionLoading) return;
            if (this.innovationEditing) {
                this.$refs.applyForm.validate(async valid => {
                    if (!valid || this.actionLoading) return;
                    const user=this.getStoredUser();
                    const enterprise=this.getEnterpriseInfo();
                    const userId=this.getUserId();
                    const centerId=String(this.applyTarget.id || '').trim();
                    if (!userId) return this.$message.warning('请先登录');
                    if (!centerId) return this.$message.warning('共创中心信息缺失');
                    if (!String(this.applyForm.name || '').trim()) return this.$message.warning('请输入共创中心名称');
                    if (!String(this.applyForm.founderName || '').trim()) return this.$message.warning('请输入创始人姓名');
                    if (!String(this.applyForm.contactPhone || '').trim()) return this.$message.warning('请输入联系电话');
                    if (this.applyForm.coverUploading) return this.$message.warning('封面图片正在上传，请稍候');
                    this.actionLoading=true;
                    try {
                        const coverImage=this.applyForm.coverFile
                            ? await this.uploadMeetingImage(this.applyForm.coverFile,'cocreation')
                            : this.applyForm.coverImage || '';
                        const response=await this.$tools.asyncPost(this,this.$baseUrl.appInnovationEdit,{ data:{
                            id:centerId,
                            name:String(this.applyForm.name || '').trim(),
                            description:String(this.applyForm.description || '').trim(),
                            address:String(this.applyForm.address || '').trim(),
                            contact_phone:String(this.applyForm.contactPhone || '').trim(),
                            cover_image:coverImage,
                            enterprise_id:String(this.applyTarget.enterprise_id || enterprise.id || '').trim(),
                            enterprise_name:String(this.applyTarget.enterprise_name || enterprise.name || '').trim(),
                            leaders:[{ id:String(this.applyForm.founderId || userId).trim(),name:String(this.applyForm.founderName || '').trim(),avatar:this.applyForm.founderAvatar || user.photo || user.avatar || user.user_avatar || '',description:user.description || user.introduction || '' }]
                        } });
                        if (response && response.data && Number(response.data.code)===0) {
                            this.applyVisible=false;
                            this.innovationEditing=false;
                            await this.fetchInnovations();
                            this.$message.success(response.data.msg || '编辑成功');
                        } else {
                            this.$message.error(response && response.data && response.data.msg || '编辑失败');
                        }
                    } catch (error) {
                        this.$message.error(error.message || '编辑失败，请稍后重试');
                    } finally { this.actionLoading=false; }
                });
                return;
            }
            if (this.applyMode==='join') {
                const userId=this.getUserId();
                const centerId=String(this.applyTarget.id || '').trim();
                if (!userId) return this.$message.warning('请先登录');
                if (!centerId) return this.$message.warning('共创中心信息缺失');
                this.actionLoading=true;
                this.$tools.asyncPost(this,this.$baseUrl.appInnovationJoin,{ data:{
                    center_id:centerId,
                    user_id:userId,
                    remark:String(this.applyForm.remark || '').trim()
                } }).then(response=>{
                    if (response && response.data && Number(response.data.code)===0) {
                        this.applyVisible=false;
                        this.$set(this.detail,'joined',true);
                        this.$set(this.detail,'member_count',Number(this.detail.member_count || 0)+1);
                        this.$message.success(response.data.msg || '申请提交成功');
                    } else {
                        this.$message.error(response && response.data && response.data.msg || '申请加入失败');
                    }
                }).catch(error=>this.$message.error(error.message || '申请加入失败')).finally(()=>{ this.actionLoading=false; });
                return;
            }
            this.$refs.applyForm.validate(async valid => {
                if (!valid) return;
                const user=this.getStoredUser();
                const userId=this.getUserId();
                const enterprise=this.getEnterpriseInfo();
                const enterpriseId=enterprise.id;
                const enterpriseName=enterprise.name;
                if (!userId) return this.$message.warning('请先登录');
                if (!enterpriseId) return this.$message.warning('企业信息缺失');
                if (!String(this.applyForm.founderName || '').trim()) return this.$message.warning('请输入创始人姓名');
                if (!String(this.applyForm.contactPhone || '').trim()) return this.$message.warning('请输入联系电话');
                this.actionLoading=true;
                try {
                    const coverImage=this.applyForm.coverFile
                        ? await this.uploadMeetingImage(this.applyForm.coverFile,'cocreation')
                        : this.applyForm.coverImage || '';
                    this.applyForm.coverImage=coverImage;
                    this.applyForm.coverFile=null;
                    const response=await this.$tools.asyncPost(this,this.$baseUrl.appInnovationAdd,{ data:{
                        name:String(this.applyForm.name || '').trim(),
                        description:String(this.applyForm.description || '').trim(),
                        address:String(this.applyForm.address || '').trim(),
                        contact_phone:String(this.applyForm.contactPhone || '').trim(),
                        cover_image:coverImage,
                        enterprise_id:enterpriseId,
                        enterprise_name:enterpriseName,
                        leaders:[{ id:userId,name:String(this.applyForm.founderName || '').trim(),avatar:user.photo || user.avatar || user.user_avatar || '',description:user.description || user.introduction || '' }]
                    } });
                    if (response && response.data && Number(response.data.code) === 0) {
                        this.applyVisible=false;
                        this.applicationRecordsLoaded=false;
                        this.currentView='cocreate';
                        await this.fetchInnovations();
                        this.$message.success(response.data.msg || '提交成功');
                    } else {
                        this.$message.error(response && response.data && response.data.msg || '申请提交失败');
                    }
                } catch (error) { this.$message.error(error.message || '申请提交失败，请稍后重试'); } finally { this.actionLoading=false; }
            });
        },
        async toggleMeetingSignup() {
            if (!this.getUserId()) {
                this.meetingActionMessage='请先登录';
                this.meetingActionMessageType='error';
                return;
            }
            await this.toggleAction('meeting');
        },
        async toggleInnovationJoin() { await this.toggleAction('innovation'); },
        async toggleAction(type) {
            const userId=this.getUserId();
            if (!userId) return this.$message.warning('请先登录');
            if (type === 'meeting') this.meetingActionMessage='';
            this.actionLoading=true;
            try {
                const active=type === 'meeting' ? Boolean(this.detail.signedUp) : Boolean(this.detail.joined);
                const url=type === 'meeting' ? (active ? this.$baseUrl.appMeetingCancelSignup : this.$baseUrl.appMeetingSignup) : (active ? this.$baseUrl.appInnovationCancelJoin : this.$baseUrl.appInnovationJoin);
                const payload=type === 'meeting' ? { meeting_id:this.detail.id,user_id:userId } : { center_id:this.detail.id,user_id:userId };
                const response=await this.$tools.asyncPost(this,url,{ data:payload },type === 'meeting' ? { suppressBusinessErrorMessage:true } : {});
                if (response && response.data && Number(response.data.code) === 0) {
                    if (type === 'meeting') this.$set(this.detail,'signedUp',!active); else this.$set(this.detail,'joined',!active);
                    if (type === 'meeting') {
                        this.meetingActionMessage=response.data.msg || (active ? '已取消报名' : '报名成功');
                        this.meetingActionMessageType='success';
                    } else this.$message.success(response.data.msg || '操作成功');
                }
            } catch (error) {
                if (type === 'meeting') {
                    this.meetingActionMessage=error.message || '操作失败，请稍后重试';
                    this.meetingActionMessageType='error';
                } else this.$message.error('操作失败，请稍后重试');
            } finally { this.actionLoading=false; }
        },
        foldshowclick() {
            this.foldshow=!this.foldshow;
            if (this.foldshow) { this.rightwidth-=265;this.leftwidth='300px'; } else { this.rightwidth+=265;this.leftwidth='35px'; }
        },
        calculateTableHeight() { this.tabmaxheight=window.innerHeight-205;this.rightwidth=window.innerWidth-(this.foldshow ? 390 : 125); },
        scroll() {
            const con=document.getElementById('con1');
            if (!con || !this.items.length) return;
            con.style.marginTop='-34px';this.animate=!this.animate;
            setTimeout(()=>{ this.items.push(this.items[0]);this.items.shift();con.style.marginTop='0px';this.animate=!this.animate; },1000);
        },
        useForumFallback(event) { if (event.target.src.indexOf(FORUM_FALLBACK) === -1) event.target.src=FORUM_FALLBACK; },
        useMemberFallback(event) { if (event.target.src.indexOf(MEMBER_FALLBACK) === -1) event.target.src=MEMBER_FALLBACK; }
    },
    beforeDestroy() { clearInterval(this.timer);window.removeEventListener('resize',this.calculateTableHeight); }
};
</script>
<style lang="scss">
#resourcelisting.overseas-pc {
    position: relative;
}

.overseas-pc > .v-modal {
    position: absolute !important;
    z-index: 90 !important;
}

.overseas-pc > .overseas-local-dialog.el-dialog__wrapper {
    position: absolute !important;
    z-index: 91 !important;
}

.overseas-detail-dialog,
.overseas-publish-dialog,
.overseas-country-dialog,
.overseas-audit-dialog,
.overseas-application-dialog,
.overseas-delete-dialog,
.overseas-participant-dialog,
.overseas-cropper-dialog {
    max-width: calc(100% - 32px);
}

.overseas-participant-dialog .el-dialog__body {
    padding: 12px 20px 8px;
}

.participant-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #909399;
}

.participant-dialog-footer .el-button + .el-button {
    margin-left: 10px;
}

.overseas-delete-dialog .el-dialog__body {
    padding: 24px;
}

.overseas-delete-confirm {
    display: flex;
    align-items: flex-start;
    color: #606266;
    line-height: 24px;
    word-break: break-all;
}

.overseas-delete-confirm .el-icon-warning {
    flex: none;
    margin: 2px 12px 0 0;
    color: #e6a23c;
    font-size: 20px;
}

.overseas-application-dialog .el-dialog__body {
    padding: 8px 20px 0;
}

.overseas-application-dialog .el-tabs__header {
    margin: 0 0 18px;
}

.overseas-application-dialog .el-tabs--top,
.overseas-application-dialog .el-tabs__header,
.overseas-application-dialog .el-tabs__content,
.overseas-application-dialog .el-tab-pane {
    float: none;
    width: 100%;
}

.overseas-application-dialog .el-tabs__nav {
    width: auto;
    height: auto;
    padding-top: 0;
    color: #606266 !important;
}

.overseas-application-dialog .el-tabs__item {
    width: auto;
    padding: 0 20px;
    color: #606266;
}

.overseas-application-dialog .el-tabs__item.is-active {
    color: #409eff;
}

.overseas-application-dialog .el-tabs__active-bar {
    height: 2px;
}

.overseas-application-dialog .el-tabs__nav-wrap::after {
    background-color: #e4e7ed;
}

.overseas-application-dialog .innovation-application-record-table {
    width: 100% !important;
}

.overseas-application-dialog .innovation-application-record-table .el-table__body-wrapper {
    overflow-y: hidden;
}

.overseas-detail-dialog .el-dialog__body {
    padding: 12px 20px 18px;
}

.overseas-publish-dialog .el-dialog__body {
    padding: 12px 20px 8px;
}

.overseas-country-dialog .el-dialog__body {
    padding: 12px 20px 8px;
}

.overseas-audit-dialog .el-dialog__body {
    padding: 18px 24px 8px;
}

.aiquill {
    .ql-container {
        height: calc(100% - 42px);
    }
}
</style>
<style scoped lang="scss">
.container {
    padding: 20px 0px;
}

.aiinfoform {
    .el-form-item {
        margin: 18px 0px 0px 0px;
    }
}

.profilelist:hover {
    background: #AEE1F1;
}

.demotitle {
    padding-left: 15px;
    border-bottom: 1px solid #f2f2f2;
    height: 40px;
    line-height: 40px;
    background: #fff;
}

.demoheader {
    background: #fff;
    padding: 10px 0px 10px 30px;
    display: flex;
    justify-ai_manual: left;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 10px;
}

.servicdivider {
    height: 6em;
}

.block {
    width: 10px;
    height: 10px;
    background: #0079FE;
    display: inline-block;
    margin-right: 5px;
}

.overseas-list-item {
    position: relative;
}

.overseas-main-columns {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    background: #f2f2f2;
}

.overseas-main-panel,
.overseas-country-sidebar {
    box-sizing: border-box;
    height: 100%;
}

.overseas-main-panel {
    overflow: hidden;
}

.overseas-country-sidebar {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.country-sidebar-header {
    box-sizing: border-box;
    flex: 0 0 50px;
}

.country-sidebar-list {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    height: auto !important;
    margin: 0;
    overflow-y: auto;
}

.country-sidebar-pagination {
    box-sizing: border-box;
    flex: 0 0 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-top: 1px solid #ebeef5;
    background: #fff;
}

.country-sidebar-pagination .el-pagination {
    padding: 6px 0;
    white-space: nowrap;
}

.overseas-list-item.has-audit-action .overseas-list-content {
    padding-right: 86px !important;
}

.overseas-list-item.has-innovation-actions .overseas-list-content {
    padding-right: 168px !important;
}

.overseas-list-item.has-meeting-actions .overseas-list-content {
    padding-right: 86px !important;
}

.overseas-list-item.has-meeting-actions.has-two-actions .overseas-list-content {
    padding-right: 168px !important;
}

.overseas-list-item.has-meeting-actions.has-two-actions.has-three-actions .overseas-list-content {
    padding-right: 250px !important;
}

.overseas-audit-button {
    position: absolute;
    top: 16px;
    right: 12px;
}

.overseas-meeting-actions {
    position: absolute;
    top: 16px;
    right: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.overseas-meeting-actions .el-button + .el-button {
    margin-left: 0;
}

.overseas-innovation-actions {
    position: absolute;
    top: 16px;
    right: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.overseas-innovation-actions .el-button + .el-button {
    margin-left: 0;
}

.meeting-participant-entry {
    position: absolute;
    right: 12px;
    bottom: 18px;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    color: #eda92a;
    font-weight: 600;
    white-space: nowrap;
}

.meeting-participant-entry .el-button {
    padding: 0;
    font-weight: 500;
}

.meeting-participant-table {
    width: 100%;
}

.audit-status-text {
    margin-left: 10px;
    font-size: 12px;
    font-weight: 400;
}

.audit-status-pending {
    color: #e6a23c;
}

.audit-status-approved {
    color: #67c23a;
}

.audit-status-rejected {
    color: #f56c6c;
}

.innovation-application-body {
    max-height: 62vh;
    overflow: auto;
}

.innovation-create-grid {
    display: grid;
    grid-template-columns: minmax(0,1fr) 400px;
    gap: 24px;
    align-items: start;
}

.innovation-create-fields,
.innovation-create-cover-item {
    min-width: 0;
}

.innovation-create-cover-item {
    width: 400px;
}

.innovation-create-cover-item .el-upload,
.innovation-create-cover-item .el-upload--text {
    display: block !important;
    width: 300px !important;
}

.innovation-application-body .el-input,
.innovation-application-body .el-textarea {
    width: 100%;
}

.innovation-cover-upload {
    box-sizing: border-box;
    width: 300px !important;
    height: 135px;
    border: 1px dashed #d9b7df;
    border-radius: 4px;
    overflow: hidden;
    background: #fafafa;
}

.innovation-cover-upload img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.innovation-cover-upload > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8d6595;
}

.innovation-cover-upload i {
    margin-bottom: 8px;
    font-size: 24px;
}

@media (max-width: 760px) {
    .innovation-create-grid {
        grid-template-columns: minmax(0,1fr);
        gap: 0;
    }

    .innovation-create-cover-item,
    .innovation-create-cover-item .el-upload,
    .innovation-create-cover-item .el-upload--text,
    .innovation-cover-upload {
        width: 100% !important;
    }
}

.application-record-cover {
    display: block;
    width: 44px;
    height: 44px;
    margin: 0 auto;
    border-radius: 4px;
    object-fit: cover;
}

.country-add-button {
    float: right;
    padding: 7px 6px;
    margin-right: 2px;
    font-size: 18px;
}

.country-sidebar-item {
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding: 8px 6px 8px 12px;
    border-bottom: 1px solid #ebeef5;
    line-height: normal;
    text-indent: 0;
}

.country-sidebar-main {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.country-sidebar-main img {
    flex: 0 0 auto;
    border-radius: 50%;
    object-fit: cover;
}

.country-sidebar-main span {
    min-width: 0;
    overflow: hidden;
    color: #606266;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.country-sidebar-actions {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

.country-sidebar-actions .el-button {
    padding: 6px;
}

.country-delete-button {
    color: #f56c6c;
}

.country-form-body {
    max-height: 68vh;
    padding-right: 8px;
    overflow-y: auto;
    overflow-x: hidden;
}

.country-editor-main {
    display: grid;
    grid-template-columns: minmax(0,1fr) 300px;
    gap: 18px;
    align-items: start;
}

.country-editor-fields,
.country-flag-form-item {
    min-width: 0;
}

.country-editor-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 18px;
}

.country-editor-fields .el-form-item:last-child {
    grid-column: 1 / -1;
}

.country-full-row {
    width: 100%;
}

.country-flag-form-item .el-upload,
.country-flag-form-item .el-upload--text {
    display: block;
    width: 180px;
}

@media (max-width: 700px) {
    .country-editor-main {
        grid-template-columns: minmax(0,1fr);
        gap: 0;
    }

    .country-editor-fields {
        display: block;
    }
}

.country-flag-upload {
    width: 180px;
    height: 102px;
    overflow: hidden;
    border: 1px dashed #c0c4cc;
    border-radius: 4px;
    background: #fafafa;
}

.country-flag-upload img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.country-flag-upload > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;
    color: #909399;
}

.country-flag-upload i {
    font-size: 26px;
}

.meeting-publish-body {
    max-height: 68vh;
    padding-right: 8px;
    overflow-y: auto;
    overflow-x: hidden;
}

.meeting-cover-upload {
    width: 210px;
    height: 96px;
    overflow: hidden;
    border: 1px dashed #c0c4cc;
    border-radius: 4px;
    background: #fafafa;
}

.meeting-cover-upload img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.meeting-cover-empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #909399;
}

.meeting-cover-empty i {
    font-size: 28px;
}

.meeting-leader-head,
.meeting-leader-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.meeting-leader-head {
    margin: 2px 0 8px 110px;
    color: #606266;
}

.meeting-leader-item {
    margin: 0 0 12px 110px;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
}

.meeting-leader-title {
    margin-bottom: 10px;
    color: #606266;
}

.meeting-leader-delete {
    color: #f56c6c;
}

.meeting-leader-avatar {
    width: 78px;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px dashed #c0c4cc;
    border-radius: 4px;
    background: #fff;
    color: #909399;
    font-size: 24px;
}

.meeting-leader-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.overseas-detail-body {
    min-height: 150px;
    max-height: 68vh;
    overflow-y: auto;
    overflow-x: hidden;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.meeting-detail-cover {
    width: 100%;
    height: 220px;
    display: block;
    object-fit: cover;
    border-radius: 4px;
}

.meeting-detail-title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 2px 10px;
}

.meeting-detail-title-row h3,
.generic-detail-title {
    min-width: 0;
    margin: 0;
    line-height: 1.55;
    color: #303133;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.meeting-detail-stats {
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    margin-bottom: 14px;
    border: 1px solid #ebeef5;
    background: #fafafa;
}

.meeting-detail-stats > div {
    min-width: 0;
    padding: 12px 8px;
    text-align: center;
    border-right: 1px solid #ebeef5;
}

.meeting-detail-stats > div:last-child {
    border-right: 0;
}

.meeting-detail-stats strong,
.meeting-detail-stats span {
    display: block;
    overflow-wrap: anywhere;
}

.meeting-detail-stats strong {
    margin-bottom: 5px;
    color: #303133;
    font-size: 16px;
}

.meeting-detail-stats span {
    color: #909399;
    font-size: 12px;
}

.meeting-detail-grid {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    column-gap: 24px;
    padding: 2px 4px 10px;
}

.meeting-detail-grid > div {
    min-width: 0;
    display: grid;
    grid-template-columns: 82px minmax(0,1fr);
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid #f2f2f2;
}

.meeting-detail-grid span {
    color: #909399;
}

.meeting-detail-grid p,
.meeting-detail-section p,
.generic-detail-text,
.meeting-person-item p {
    min-width: 0;
    margin: 0;
    line-height: 1.75;
    color: #606266;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.meeting-detail-section {
    padding: 12px 4px;
    border-bottom: 1px solid #ebeef5;
}

.meeting-detail-section h4 {
    margin: 0 0 9px;
    color: #303133;
}

.meeting-person-list {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: 10px;
}

.meeting-person-item {
    min-width: 0;
    display: flex;
    gap: 10px;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.meeting-person-item img,
.meeting-signup-list img {
    flex: 0 0 auto;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    object-fit: cover;
}

.meeting-person-item > div {
    min-width: 0;
}

.meeting-person-item strong,
.meeting-person-item span {
    display: block;
    overflow-wrap: anywhere;
}

.meeting-person-item span {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
}

.meeting-signup-list {
    display: grid;
    grid-template-columns: repeat(5,minmax(0,1fr));
    gap: 10px;
}

.meeting-signup-list > div {
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    color: #606266;
    text-align: center;
}

.meeting-signup-list span {
    width: 100%;
    overflow-wrap: anywhere;
}

.meeting-detail-empty {
    color: #909399 !important;
}

.meeting-detail-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.meeting-action-message {
    min-width: 0;
    color: #f56c6c;
    line-height: 20px;
    text-align: left;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.meeting-action-message.is-success {
    color: #67c23a;
}

.meeting-action-message i {
    margin-right: 5px;
}

.generic-detail-title {
    margin: 14px 0 8px;
}

.generic-detail-text {
    margin-bottom: 8px;
}

@media (max-width: 900px) {
    .meeting-detail-grid,
    .meeting-person-list {
        grid-template-columns: minmax(0,1fr);
    }

    .meeting-signup-list {
        grid-template-columns: repeat(3,minmax(0,1fr));
    }
}

@import 'resource.css';
</style>
